const noticias = [
  {
    id: 1,
    titulo: "QUIMSA ENFRENTARÁ A OBRAS POR LOS CUARTOS DE FINAL",
    categoria: "Playoffs Liga Nacional",
    fecha: "3 Junio 2025",
    imagen: "/noticias/quimsa-vs-obras.jpeg", // colocá una imagen válida local o externa
    contenido: `Obras Sanitarias superó la etapa de reclasificación ante Atenas y será el rival de la Fusión en cuartos de final.

Quimsa terminó cuarto con un récord de 25 triunfos y 13 derrotas mientras que el Tachero culminó quinto con 24 victorias. En la etapa regular se enfrentaron dos veces, el 5 de noviembre Obras lo ganó 78 a 64 como local mientras que la Fusión se impuso el 16 de abril en el Ciudad por 96 a 72 para quedar arriba en el historial por La Liga 26 a 20 ante Obras.

El equipo santiagueño se enfrentó a Obras Sanitarias en el Torneo Nacional de Ascenso (ahora llamado La Liga Argentina) en semis de la temporada 2005/06 donde Quimsa se impuso en la serie 3 - 1 para lograr el histórico ascenso a la élite del básquet nacional. En La Liga se vieron las caras unos años después cuando la Fusión se quedaría con las semis de la 2007/08 3 a 0 ante el equipo de Ciudad de Buenos Aires para avanzar a la final donde caería ante Libertad de Sunchales. En los playoffs 2010/11 Quimsa superaría nuevamente a dicho rival, en esta oportunidad en cuartos de final 3 a 1.

Ahora se verán las caras en un mano a mano para avanzar a las semifinales del torneo con posibilidad de encontrar un cupo a torneos internacionales de la próxima temporada.

La serie comenzará en el Estadio Ciudad y se espera la confirmación de las fechas.`
  },
  {
    id: 2,
    titulo: 'LEANDRO RAMELLA: "FUIMOS COMPETITIVOS Y TERMINAMOS JUGANDO BIEN PARA MERECER EL CUARTO LUGAR"',
    categoria: "Declaraciones",
    fecha: "3 Junio 2025",
    imagen: "/noticias/ramella.jpeg", // colocá una imagen válida local o externa
    contenido: `El entrenador de Quimsa habló en la previa a los playoffs, el balance de la fase regular en un torneo parejo y las cosas por mejorar en esta etapa.

Sobre el balance previo a la postemporada el oriundo de Mar del Plata dijo: "Creo que en el inicio de la temporada nos costó mucho ser regulares, lo que sí conseguimos luego y nos pusimos bastante competitivos en una competencia que fue así donde hubo poca diferencia entre partidos ganados y perdidos entre los equipos, donde con un par de triunfos estabas adentro de playoffs o incluso entre los cuatro primeros.

Fue una fase regular muy pareja, hace tiempo que los equipos de arriba no perdían tantos partidos, cuando en otras temporadas esto no pasaba. Dentro de esta liga muy pareja, con altos y bajos, fuimos competitivos y terminamos jugando bien para merecer estar entre los primeros cuatro gracias a una segunda parte del torneo fue buena", declaró el coach que obtuvo La Liga 2022/23 con su llegada a Santiago del Estero.

El ex Peñarol agregó: "Pienso que tenemos que corregir algunas situaciones defensivas, ajustarlas y en ofensivas de ocupación de espacio y lectura de situación nos darán un plus. Uno puede agregar algo en playoffs, en lo personal no me gusta sumar muchas cosas nuevas, busco afinar en lo construido hasta ahora y en esos detalles tratar de sacar la ventaja", cerró el entrenador de 50 años.

Quimsa se mantiene entrenando en el Estadio Ciudad a la espera de conocer a su rival de cuartos de final.`
  },
  {
  id: 3,
  titulo: 'QUIMSA ABRE LOS CUARTOS DE FINAL RECIBIENDO A OBRAS',
  categoria: 'Partido',
  fecha: '5 Junio 2025',
  imagen: '/noticias/quimsa-obras.jpg', // reemplazá con una imagen válida local o externa
  contenido: `La Fusión recibe desde las 22 horas en el Estadio Ciudad a Obras Sanitarias por el primer juego de la serie.

La llave de cuartos de final entre Quimsa (cuarto en la fase regular) clasificado directamente a esta instancia y Obras Sanitarias (quinto eliminando a Atenas en reclasificación) tendrá su inicio este viernes desde las 22 horas en el Estadio Ciudad.

En la etapa regular se enfrentaron dos veces. El 5 de noviembre, Obras ganó 78 a 64 como local, mientras que la Fusión se impuso el 16 de abril en el Ciudad por 96 a 72 para quedar arriba en el historial por La Liga 26 a 20 ante Obras.

El equipo santiagueño ya se enfrentó al "Tachero" en el Torneo Nacional de Ascenso, en las semifinales de la temporada 2005/06, donde Quimsa se impuso 3 - 1 para lograr el histórico ascenso a la élite del básquet nacional. En La Liga, volvieron a verse las caras en las semifinales de la 2007/08, con victoria de la Fusión por 3 - 0, avanzando a la final donde luego caería ante Libertad de Sunchales. En los playoffs 2010/11, Quimsa superó nuevamente a Obras, en esta ocasión en cuartos de final 3 - 1.

Ahora se reencontrarán en un nuevo mano a mano por un lugar en semifinales, y con la posibilidad de alcanzar un cupo a torneos internacionales en la próxima temporada.

En la previa del torneo, el entrenador Leandro Ramella afirmó: "Tenemos que corregir algunas situaciones defensivas, ajustarlas, y en ofensivas trabajar en la ocupación de espacio y lectura de situación porque nos darán un plus. Uno puede agregar algo en playoffs, pero en lo personal no me gusta sumar muchas cosas nuevas, busco afinar en lo construido hasta ahora y en esos detalles tratar de sacar la ventaja".

Oscar Britez, Julio Dinamarca y Alberto Ponzo serán los árbitros para este juego 1.

Las entradas podrán adquirirse en la web Passline.com.`
},
{
  id: 4,
  titulo: 'QUIMSA PEGÓ PRIMERO EN LOS CUARTOS DE FINAL',
  categoria: 'Partido',
  fecha: '6 Junio 2025',
  imagen: '/noticias/partido-obras1.jpeg',
  contenido: `
    <p>La Fusión recibe desde las 22 horas en el Estadio Ciudad a Obras Sanitarias por el primer juego de la serie.</p>

    <p>La Fusión comenzó la serie de playoffs con un triunfo frente a Obras Sanitarias por 78 a 67 con 18 puntos de Nicolás Romano. El domingo seguirá la serie por los cuartos de final.</p>

    <img src="/noticias/partido-obras2.jpeg" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />

    <p>En los primeros minutos el protagonista fue el dueño de casa con Robinson a distancia y en cercanías al canasto con Miller, Obras intentó con Mata pero Robinson siguió encendido para poner el 12 a 4. Calfani con un par de aciertos logró descontar, Quimsa mantuvo la distancia con el ingreso de Romano y un doble de Zezular para 24 a 14 en el primer segmento.</p>

    <p>El duelo siguió con un par de minutos erráticos en ambos lados hasta que los dirigidos por Ramella encontraron puntos con Pérez Tapia para seguir al frente. La visita no estaba firme desde el perímetro (uno de doce en triples) y el elenco santiagueño aumentó cifras con las bombas de Romano y Brussino para irse al entretiempo con un claro 44/28 a su favor.</p>

    <img src="/noticias/partido-obras3.jpeg" alt="Romano lanzando" style="max-width:100%; margin: 20px 0;" />

    <p>Mata intentó despertar al Tachero, pero un par de anotaciones de Louis junto a un triple de Miller mantuvieron la calma para el dueño de casa. Obras mejoró el tiro de tres puntos con Schattmann, con diez minutos para el final Quimsa seguía mandando, 64 a 48.</p>

    <p>El último cuarto fue parejo, Sansimoni junto a Romano anotaron para el dueño de casa, en el equipo de coach Fabbris movieron el score Barral y Clarke. Triunfo de la Fusión 78/67 para ponerse uno a cero arriba en la serie de cuartos de final. Nicolás Romano sumó 18 tantos y 7 rebotes además Brando Robinson 15 tantos y Tavario Miller doble doble con 13 puntos con 11 rebotes.</p>

    <p>La serie continuará este domingo desde las 21:30 en el Estadio Ciudad.</p>
  `
},
{
  id: 5,
  titulo: 'QUIMSA SOLIDARIO PASÓ POR OJO DE AGUA',
  categoria: 'Solidario',
  fecha: '7 Junio 2025',
  imagen: '/noticias/quimsasolidario2.jpg',
  contenido: `
    <p>Quimsa visitó el Polideportivo de Villa Ojo de Agua donde fue recibido por la Escuela de Básquet Amateur (EBA) Ojo de Agua quién disputó un encuentro amistoso ante Colonia Dora. 
</p>

    <p>Durante su visita el plantel de La Liga de Desarrollo de la Fusión tuvo tiempo de compartir juegos y gratos momentos donde se incluyó una charla por parte de los jugadores para contar sus experiencias y vivencias en el deporte en un ida y vuelta de preguntas junto a los niños presentes en el Polideportivo.</p>

    <img src="/noticias/quimsasolidario1.jpg" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />

    <p>El profesor de la escuela local, Juan Chazarreta dijo "Para nosotros es algo muy especial recibir a una institución como Quimsa, hace 13 años que venimos trabajando y que nos visiten es algo muy lindo sobre todo para los chicos que pudieron compartir la jornada junto a los jugadores"</p>

    <p>Acompañaron a la delegación Lucía Suárez como dirigente de la institución, el Psicólogo Lic. Alvaro Anauate y la nutricionista Lic. Daniela Caceres. En el medio se disputó una serie de encuentros de minibásquet entre Ojo de Agua y Colonia Dora</p>


    <p>De esta manera el club continúa con su proyecto de QUIMSA SOLIDARIO demostrando ser participe activo en la sociedad santiagueña visitando una nueva ciudad de la provincia.</p>

    
  `
},
{
  id: 6,
  titulo: 'QUIMSA VOLVIÓ A GANAR Y QUEDÓ A UN PASO DE LAS SEMIFINALES',
  categoria: 'Partido',
  fecha: '8 Junio 2025',
  imagen: '/noticias/partido2-obras1.JPG',
  contenido: `
    <p> La Fusión superó a Obras Sanitarias por 88 a 65 como local y buscará este miércoles meterse nuevamente en semis de La Liga. Brandon Robinson fue el goleador con 23 puntos. 
</p>


    <img src="/noticias/partido2-obras2.JPG" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />

    <p>El duelo comenzó con dos equipos erráticos en ataque, en cuatro minutos apenas triples de Robinson y Miller para el local, mientras que Clarke movía el score de Obras. Los puntos llegaron para los dos con Robinson (12 puntos) y Clarke (ocho) como protagonistas en un primer cuarto parejo que quedó en manos de los santiagueños solamente por 21 a 20. 
Sansimoni y Romano aumentaron cifras para un Quimsa que ajustó su defensa permitiendo solamente dos puntos a la visita en cinco minutos. El equipo dirigido por Fabbris no encontraba el rumbo, la Fusión se iba al entretiempo con un firme 41 a 24. 
Robinson abrió el complemento con un doble con falta y Miller también aportó lo suyo para un parcial de siete a cero en dos minutos. Obras encontró algunas soluciones con el juego individual de Clarke y el aporte de Mata, pero los santiagueños siguieron sumando con su segunda unidad en cancha con Basabe y Vasirani para sostener la renta a su favor. Mainoldi a larga distancia pudo descontar pero a falta de diez minutos el dueño de casa seguía arriba 66 a 54. 
En tres minutos una nueva ráfaga de puntos para los dirigidos por Ramella acomodaba la ventaja gracias a  Sansimoni y Pérez Tapia. Obras Sanitarias siguió con Mainoldi desde la vía de tres puntos pero Sansimoni respondió con la misma moneda, la Fusión lo cerró controlando el tiempo y el goleo con la dupla Robinson - Miller para llevarse el segundo punto de la serie por 88 a 65.
Brandon Robinson se destacó con 23 puntos, además Bruno Sansimoni 20 tantos con 5 asistencias. En la visita Chris Clarke 18 puntos y 10 rebotes. </p>

    <img src="/noticias/partido2-obras3.JPG" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />


    <p>La serie (2 a 0 para Quimsa) seguirá en el Templo del Rock de Obras Sanitarias este miércoles donde un triunfo santiagueño terminará la llave de cuartos de final y una victoria del Tachero llevaría a un juego cuatro el viernes.</p>

    
  `
},
{
  id: 7,
  titulo: 'SANSIMONI "TENEMOS QUE JUGAR TODOS LOS PARTIDOS HASTA EL FINAL"',
  categoria: 'Declaraciones',
  fecha: '9 Junio 2025',
  imagen: '/noticias/sansimoni1-obras2.jpeg',
  contenido: `
    <p> El base de Quimsa tuvo un gran juego para que su equipo quede a un paso de las semifinales. 
</p>



    <p>El oriundo de Olavarría destacó luego del triunfo de la Fusión "La clave estuvo en la intensidad, mantenerla los cuarenta minutos. Logramos sacar ventaja defendiendo en el segundo cuarto así que buscaremos seguir de esta manera porque la serie no se termina aún, no importa si vamos dos a cero o uno a uno, tenemos que jugar todos los partidos hasta el final" el ex Peñarol y Quimes de Mar del Plata también agregó "No tenemos que relajarnos, si bien defendimos intensos hay cosas por corregir sobre todo cuando nos anotaron puntos que podíamos evitar así que seguramente lo trabajaremos estos días" </p>

    <img src="/noticias/sansimoni2-obras2.jpeg" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />


    <p>El jugador autor de 20 puntos en el juego del domingo cerró "Obras es un equipo con mucha experiencia que no tiene en sus planes rendirse fácilmente, van a jugar hasta el final por lo que nosotros también lo haremos". </p>
    <p>Quimsa estará partiendo rumbo a Buenos Aires este lunes donde el miércoles tendrá la posibilidad de abrochar su pase a semifinales de La Liga. </p>

    
  `
},
{
  id: 8,
  titulo: 'LA FUSIÓN Y UNA NUEVA SEMIFINAL"',
  categoria: 'Partido',
  fecha: '11 Junio 2025',
  imagen: '/noticias/partido3-obras1.jpeg',
  contenido: `
    <p> El base de Quimsa habló luego del agónico triunfo ante Obras para barrer la serie y meterse entre los cuatro mejores de La Liga.
</p>

    <img src="/noticias/partido3-obras2.jpeg" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />


    <p>Figura del encuentro anotando el doble decisivo además de sus habituales asistencias el capitán de Quimsa destacó "Feliz de estar nuevamente en esta instancia, la clave fue nuestra localía ganando los dos partidos en casa para llegar a Buenos Aires con una tranquilidad y sabiendo las cosas que teníamos por mejorar" también agregó "En el partido hicimos las cosas bien, pudimos sacar diez puntos de ventaja, Obras tuvo un gasto importante descontando en el segundo tiempo pero seguimos en partido siempre manteniendo nuestro eje priorizando lo colectivo sobre lo individual para llegar a un final cerrado donde teniendo jugadores de experiencia logramos sacar la ventaja para ganarlo".  </p>

    <img src="/noticias/partido3-obras3.jpeg" alt="Primer duelo Quimsa vs Obras" style="max-width:100%; margin: 20px 0;" />


    <p>El ex Libertad e Instituto remarcó "Se acomodaron los roles en el equipo, siempre buscamos lo mejor para Quimsa ante todo rival, sabemos la importancia de la camiseta que representamos para llegar a estas instancias" además el oriundo de Cañada de Gómez declaró "Tenemos que descansar, disfrutar jugar unas semifinales y ante el rival que nos toque saber que tenemos el acompañamiento de la gente para seguir soñando y querer llegar a la final". </p>

        <p>Quimsa está a la espera de su rival que saldrá entre Boca y Ferro, donde el Verdolaga tiene la serie dos a uno a su favor y este viernes disputarán el cuarto juego. </p>

  `
},
{
  id: 9,
  titulo: 'BRUSSINO TRAS EL PASO A SEMIFINALES "MANTENER NUESTRO EJE PRIORIZANDO LO COLECTIVO SOBRE LO INDIVIDUAL" ',
  categoria: 'Declaraciones',
  fecha: '12 Junio 2025',
  imagen: '/noticias/brusino1.jpeg',
  contenido: `
    <p> La Asociación Atlética Quimsa dejó en el camino a Obras Sanitarias y espera por el ganador de la serie entre Boca y Ferro, será vez que la Fusión dispute semifinales de La Liga. 
</p>



    <p>En la 2007/08 (la segunda temporada del club en élite) jugó semis ante Obras superando la instancia 3 a 0 y cayendo luego en la definición ante Libertad de Sunchales. 
El equipo santiagueño llegaría nuevamente a instancias de semis en la temporada 2010/11 cayendo en tres partidos frente Atenas de Córdoba. 
En el campeonato de La Liga 2014/15 al mando de Silvio Santander, Quimsa superó en semis a San Martín de Corrientes por 3 a 1.
Seis temporadas después la Fusión lograría el subcampeonato ante San Lorenzo por la 2020/21, en semifinales eliminó a Boca por 2 a 0.
En la 2021/22 una nueva final llegaba para los dirigidos por González, en semis superaron al Xeneize por 3 a 1 y perdieron en la final ante Instituto. 
La temporada 2022/23 donde obtendrían el campeonato con coach Ramella al mando, la semifinales fueron ante Gimnasia de Comodoro Rivadavia barriendo la serie 3 a 0 y en La Liga pasada 2023/24 la Fusión perdería en semifinales ante Boca en quinto juego.  </p>



    <p>Quimsa se aseguró un cupo a los torneos internacionales y espera por su rival (Boca o Ferro) para definir al finalista de La Liga 2024/25. </p>

    
  `
},
{
  id: 10,
  titulo: 'COMUNICACIÓN Y GESTIÓN DEPORTIVA: ESTUDIANTES DEL ISPP PARTICIPARON DE UNA JORNADA JUNTO A QUIMSA ',
  categoria: 'Formación Profesional',
  fecha: '12 Junio 2025',
  imagen: '/noticias/quimsa-ispp.jpeg',
  contenido: `
    <p> En un contexto donde el deporte exige cada vez más profesionales integrales, el Instituto Superior del Profesorado Provincial (ISPP) en el marco del convenio con Quimsa a estudiantes del Profesorado de Educación Física y de la Tecnicatura en Organización y Gestión Deportiva participaron de una jornada sobre comunicación, redes y estrategias institucionales en el deporte.
</p>



    <p>La charla, a cargo de Fátima Rodríguez y Manuel Roldán, integrantes del área comunicacional del club, se centró en herramientas clave para el desarrollo de una imagen profesional, la difusión de eventos deportivos y el vínculo entre instituciones, medios y públicos. Se abordaron conceptos como planificación de contenido, estrategias de prensa, redes sociales aplicadas al deporte y gestión de alianzas estratégicas.  </p>



    <p>Desde el ISPP, destacaron la importancia de formar a docentes y técnicos capaces de liderar no solo desde el saber físico o pedagógico, sino también desde la comunicación estratégica y la gestión integral del deporte, con herramientas adaptadas a los tiempos actuales.n </p>

    
  `
},
{
  id: 11,
  titulo: 'LEANDRO RAMELLA Y UNA NUEVA SEMIFINAL CON QUIMSA',
  categoria: 'Declaraciones',
  fecha: '14 Junio 2025',
  imagen: '/noticias/ramella-semifinal.jpeg',
  contenido: `
    <p>El entrenador Leandro Ramella, oriundo de Mar del Plata y en su tercera temporada al frente de Quimsa, habló tras una nueva clasificación a semifinales de Liga Nacional, en la que la Fusión aguarda rival entre Boca y Ferro.</p>

    <p>"Es algo muy lindo llegar a una semifinal. El club hace varias temporadas que lo viene consiguiendo, y si bien parece algo normal, se logra con mucho esfuerzo. Es mérito de los jugadores, tras una temporada que comenzó de forma irregular pero en la que nunca dejaron de luchar ni de pensar en el equipo", destacó el coach.</p>

    <p>Respecto a la serie 3-0 ante Obras, Ramella valoró la calma y el enfoque del equipo: "No nos desesperamos. Cuando uno lleva una ventaja y luego el juego entra en pasajes palo a palo, los jugadores mantuvieron la templanza, incluso estando abajo en el score. Estar bien física y emocionalmente son dos ítems clave para nosotros".</p>

    <p>Consultado sobre el nivel de la competencia, agregó: "Se están viendo llaves muy parejas, algo similar a lo que vimos en la etapa regular. Hace muchos años que no veo una Liga tan pareja y dura. Creo que las semifinales también serán así".</p>

    <p>Sobre el posible cruce con Ferro o Boca, analizó: "Ferro trabaja muy bien desde su línea de juego y merecidamente compite de igual a igual ante un Boca con mucha jerarquía. Es difícil ganarle tres partidos, o cuatro en una hipotética final. El que se encuentre mejor en el quinto juego podrá dar ese paso adelante", concluyó el DT.</p>

    <p>Quimsa conocerá su rival este lunes, cuando se defina la serie entre el equipo Xeneize y el conjunto de Caballito.</p>
  `
},
{
  id: 12,
  titulo: 'QUIMSA ENFRENTARÁ A BOCA EN SEMIFINALES DE LA LIGA',
  categoria: 'Básquet Profesional',
  fecha: '16 Junio 2025',
  imagen: '/noticias/quimsa-vs-boca.jpeg',
  contenido: `
    <p>Quimsa y Boca volverán a cruzarse en una nueva instancia de playoffs de La Liga Nacional. Esta vez será por las semifinales, con inicio confirmado para este domingo 22 de junio en la Bombonerita.</p>

    <p>El historial entre ambos en instancias decisivas es extenso. Todo comenzó en la temporada 2011/12 con la serie de reclasificación que ganó el Xeneize 3-1. En la 2020/21, en formato burbuja por la pandemia, Quimsa se impuso 2-0 y avanzó a la final que luego perdería ante San Lorenzo. En la 2021/22, los santiagueños volvieron a vencer en semifinales 3-1 y llegaron a la final ante Instituto. La rivalidad se consolidó en la final de la 2023/24, donde Quimsa se consagró campeón tras ganar la serie 4-1. Sin embargo, Boca tuvo su revancha en la temporada pasada, eliminando a la Fusión en semifinales en un quinto juego muy reñido.</p>

    <p>Este será el sexto cruce entre ambos en playoffs, consolidando a Quimsa, Boca e Instituto como los grandes protagonistas de las últimas definiciones de La Liga.</p>

    <p>Durante la presente temporada se enfrentaron en tres oportunidades. Boca ganó la Súpercopa por 90 a 75, mientras que Quimsa se impuso en los dos partidos de fase regular: 97 a 67 en el Estadio Ciudad con 17 puntos de Nicolás Brussino y 90 a 75 en la Bombonerita con 14 puntos de Agustín Pérez Tapia.</p>

    <p><strong>Historial general:</strong> Se enfrentaron 55 veces por Liga Nacional, con 34 victorias para Quimsa y 21 para Boca.</p>

    <p><strong>Fechas confirmadas para las semifinales:</strong></p>

    <ul>
      <li><strong>Juego 1:</strong> Domingo 22/6 – en Boca</li>
      <li><strong>Juego 2:</strong> Martes 24/6 – en Boca</li>
      <li><strong>Juego 3:</strong> Viernes 27/6 – en Estadio Ciudad</li>
      <li><strong>*Juego 4:</strong> Domingo 29/6 – en Estadio Ciudad (si es necesario)</li>
      <li><strong>*Juego 5:</strong> Miércoles 2/7 – en Boca (si es necesario)</li>
    </ul>

    <p>Quimsa se prepara para una serie intensa y apasionante frente a uno de sus clásicos rivales de los últimos años.</p>
  `
},
{
  id: 13,
  titulo: 'QUIMSA VISITA A BOCA EN EL INICIO DE LA SERIE DE SEMIFINALES',
  categoria: 'Básquet Profesional',
  fecha: '21 Junio 2025',
  imagen: '/noticias/quimsa-visita-boca.jpeg',
  contenido: `
    <p>Este domingo desde las 22:10 horas, Quimsa comenzará a disputar la serie de semifinales de La Liga Nacional frente a Boca Juniors. El primer juego, al mejor de cinco, será televisado por TyC Sports 2 desde La Bombonerita.</p>

    <p>La Fusión llega a esta instancia tras finalizar cuarta en la fase regular con un récord de 25 triunfos y 13 derrotas. En cuartos de final, barrió 3-0 a Obras Sanitarias. Por su parte, Boca terminó primero con 29 victorias y necesitó cinco juegos para superar a Ferro y meterse en semis.</p>

    <p>El cruce entre santiagueños y xeneizes ya es un clásico de los últimos años. En playoffs se enfrentaron cinco veces: en 2011/12 Boca ganó 3-1 en reclasificación; en 2020/21 Quimsa se impuso 2-0 en burbuja sanitaria; en 2021/22 ganó 3-1 para llegar a la final ante Instituto; en 2023/24 la Fusión fue campeón tras ganar la final 4-1; y la pasada temporada, Boca se tomó revancha al ganar en el quinto juego de semifinales.</p>

    <p>En esta temporada se midieron en tres oportunidades: Boca ganó la Súpercopa 90-75, pero Quimsa triunfó en los dos juegos de fase regular, 97-67 en el Estadio Ciudad (con 17 puntos de Brussino) y 90-75 en la Bombonerita (con 14 puntos de Agustín Pérez Tapia).</p>

    <p><strong>Historial:</strong> Se enfrentaron 55 veces en La Liga, con 34 victorias para Quimsa y 21 para Boca.</p>

    <p>En la previa del duelo, el alero Emiliano Basabe expresó: "Sabemos que es un rival muy duro y fuerte de local. Nosotros venimos de una buena serie ante Obras, buscaremos defenderlos porque tienen mucho gol, no dejarlos correr y estar tranquilos en nuestras ofensivas".</p>

    <p><strong>Árbitros para el Juego 1:</strong> Juan Fernández, Alejandro Zanabone y Gonzalo Delsart.</p>

    <p>La serie continuará el <strong>martes 24/6 a las 21:10 horas</strong> nuevamente en La Bombonerita.</p>
  `
},
{
  id: 14,
  titulo: 'QUIMSA CAYÓ ANTE BOCA EN EL INICIO DE LA SERIE DE SEMIFINALES ',
  categoria: 'Básquet Profesional',
  fecha: '22 Junio 2025',
  imagen: '/noticias/quimsa-visita-boca-juego1.jpeg',
  contenido: `
    <p>La Fusión no tuvo su mejor versión y perdió en el juego uno ante Boca en la Bombonerita por 70 a 58. La serie seguirá el martes.</p>

    <p>El partido comenzó con un visitante muy errático (solamente un triple de Robinson en cinco minutos) mientras que Boca con Delia intratable cerca del aro sacaba una distancia de ocho a tres. Brussino a larga distancia emparejaba un poco, pero Ibargüen llegó desde el banco para mantener arriba al dueño de casa. Tras un flojo cierre de cuarto para los dos, arriba Boca 15 a 13.</p>

    <p>Triples de Scala y Giorgetti ampliaron la brecha para el Xeneize, Quimsa intentó descontar con los cuatro puntos seguidos de Romano mientras que los dirigidos por Pérez encontraron soluciones con Vega y Scala para seguir al frente. La dupla Louis - Miller limaron la brecha, el Xeneize se iba al entretiempo ganando por la mínima 31 - 30. </p>

    <p>Luego del descanso principal el equipo santiagueño tuvo una nueva laguna ofensiva, Brussino anotó los siete puntos de la Fusión en seis minutos, el local se mantenía con un Vildoza protagonista en ataque. Robinson dijo presente en el aro rival y Miller en la pintura permitieron que la visita pase al frente por un punto, un tiro de Cuello cerró el segmento, Boca comandaba 60/58 con diez minutos por jugar. </p>

    <p>Cuello junto a Ibargüen con un parcial de siete a cero acomodaban de nuevo al campeón defensor de La Liga, los dirigidos por coach Ramella no tardaron en contestar con Pérez Tapia pero luego fallaron tres ofensivas y Boca no perdonó con Ibargüen para una luz de ocho puntos con 5'49" en el reloj. Luego de un pasaje errático en ambos canastos, el Xeneize amplió con libres y un triple de Scala para manejar el cierre apoyándose en el tiempo que se consumía. Triunfo de Boca ante Quimsa por 70 a 58.</p>

    <p>Santiago Scala se destacó con 15 puntos y lo acompañó Matías Cuello con 14. En la visita Brandon Robinson y Juan Brussino anotaron 12 cada uno. </p>
        <p>La serie seguirá este martes desde las 21:10 horas nuevamente en La Bombonerita. </p>

  `
},
{
  id: 15,
  titulo: 'QUIMSA VOLVIÓ A PERDER ANTE BOCA Y QUEDÓ A UN PASO DE LA ELIMINACIÓN  ',
  categoria: 'Básquet Profesional',
  fecha: '25 Junio 2025',
  imagen: '/noticias/quimsa-visita-boca-juego2.jpeg',
  contenido: `
    <p>La Fusión no pudo ante el Xeneize y perdió 87/70 quedando al borde de la eliminación. La serie se traslada al Estadio Ciudad este viernes donde los dirigidos por Ramella tendrán que ganar para estirar las semifinales. </p>

    <p>El duelo comenzó con el dueño de casa efectivo a larga distancia con Vega y Vildoza para sacar ventaja de once, Quimsa llegó desde atrás con el tiro de Brussino y el juego interior de Miller para meterse en el juego. El cierre de cuarto fue entre un Vildoza desequilibrante y un Sansimoni que a fuerza de triples ponía a la visita arriba 28/26. </p>

    <p>El banco santiagueño sacó ventaja de siete con Sansimoni y Zezular pero el campeón defensor no tardó en contestar mediante Cuello y Cooper en un pasaje de alto goleo. Ambos elencos buscaron mejorar sus defensas, antes del descanso principal Vildoza con siete puntos seguidos colocaba a los dirigidos por Pérez adelante 50/44.  </p>

    <p>Basabe y Miller abrían el score visitante en el complemento pero las falencias defensivas permitieron a Boca tomar tiros cómodos y efectivos con Delia, Cuello y Giorgetti para escaparse en el tanteador. Zezular desde el perímetro pudo descontar, pero Guerrero contestó de igual manera para que el dueño de case lidere 70/55 con un cuarto por disputarse.  </p>

    <p>En tres minutos solamente un doble por lado mantenían la distancia. El Xeneize anotó con un par de bombas de Vildoza para sacar la máxima frente a un Fusionado que buscó con Pérez Tapia pero Vega a larga distancia apagó las chances de los dirigidos por Ramella. Boca manejó el cierre para llevarse el duelo por 87/70 y quedar a un triunfo de una nueva final. José Vildoza la rompió con 31 puntos y 6 asistencias, además de los 10 tantos de Marcos Delía. En los de Santiago del Estero, Tavario Miller 17 tantos con 12 rebotes y Bruno Sansimoni 9 puntos. </p>

    
  `
},
{
  id: 16,
  titulo: 'BOCA PASÓ LA ESCOBA Y ELIMINÓ A QUIMSA PARA METERSE EN LA FINAL DE LA LIGA ANTE INSTITUTO   ',
  categoria: 'Básquet Profesional',
  fecha: '27 Junio 2025',
  imagen: '/noticias/quimsa-bocafinal.jpeg',
  contenido: `
    <p>La visita comenzó mejor con los tiros de Scala y Giorgetti para el 10 a 4 en cuatro minutos ante un Quimsa que solamente sumó con un par de dobles de Robinson y Romano. Luego de un minuto del entrenador Ramella, el local se acomodó con Brussino y Miller para emparejar el score. Tras un pasaje errático para ambos, el primer segmento quedaba en manos de la Fusión gracias a los aciertos de Zezular y Robinson para el 19 a 15.  <p>
    <p>En el segundo cuarto llegaron los triples de Robinson, Cooper, Cuello y Sansimoni para mover el tanteador en cada lado en un juego que nuevamente estaba palo a palo. En un final de primer tiempo equitativo, Ibargüen cerca del aro le dió la ventaja al campeón defensor de La Liga 36/33 rumbo al entretiempo.  </p>

    <p>Scala y Giorgetti a distancia abrieron el complemento para que Boca saque diferencia de nueve puntos, el dueño de casa contestó con arrestos de Brussino y Basabe. Luego de unos minutos de paridad, el Xeneize sacó ventaja con Vega y Delía para el 60/52 a falta de diez minutos. 
 <p>El inicio del cuarto final fue todo azul y oro con Delía y un par de dobles de Cuello para sacar una renta de 16 puntos con 6'15" en el reloj. Los dirigidos por Ramella reaccionaron con seis tantos de Romano y Zezular,  Boca no se apoyó en la ventaja y el tiempo para cerrarlo, cometió pérdidas y le dió vida a la Fusión que anotó con Pérez Tapia y un triple de Louis. Vildoza con un par de libres a falta de cuatro segundos puso el 83 a 80 final que mandó al último campeón de La Liga nuevamente a la final ante Instituto de Córdoba. José Vildoza sumó 21 puntos con 6 asistencias y Sebastián Vega 15 unidades. En el equipo santiagueño, 18 para Nicolás Romano.   </p>

    <p>De esta manera la Asociación Atlética Quimsa termina su participación en La Liga finalizando su temporada.  </p>


    
  `
},

{
  id: 17,
  titulo: 'LOS JUVENILES DE QUIMSA SE QUEDARON CON EL TORNEO LOCAL ',
  categoria: 'Juveniles',
  fecha: '3 Julio 2025',
  imagen: '/noticias/juveniles-local-torneo.jpeg',
  contenido: `
    <p>Quimsa superó a Nicolás Avellaneda en el estadio Ciudad por 63 a 56 en un juego muy disputado de principio a fin para cerrar la serie final 2 a 0 y levantar el torneo Apertura local en la categoría U21.   <p>
    <p>Los dirigidos por Cristian "Ñaña" Suárez se quedaron con el juego uno por 76 a 70 en el Barrio Mosconi y el segundo duelo por 63 a 56. La figura de la serie fue Jeremías Yonni además del gran trabajo de Ian Saavedra e Ignacio Pizarro.  </p>

    

    
  `
},
{
  id: 18,
  titulo: 'QUIMSA SERÁ SEDE DE LA LIGA FEDERAL FORMATIVA U17 FEMENINA ',
  categoria: 'Femenino',
  fecha: '4 Julio 2025',
  imagen: '/noticias/u17ligafederalfemenina.jpeg',
  contenido: `
    <p>Quimsa será anfitrión de uno de los cuadrangulares de La Liga Federal Formativa U17 de la rama femenina.  <p>
    <p> Además de la Fusión dirán presentes Olímpico de La Banda, Municipalidad Luján de Cuyo y Urquiza de San Juan. Los partidos serán el sábado 5 y domingo 6 (doble jornada) donde al enfrentarse todos contra todos, los mejores equipos avanzarán de ronda en el torneo organizado por la Confederación Argentina de Básquet. </p>
    <p> Quimsa viene de lograr ante Olímpico la liga femenina local U17 hace unas semanas en dos juegos emocionantes por lo que se espera un gran marco de público en el Estadio Ciudad. Las dirigidas por Germán Brao buscarán ser protagonistas en este torneo contando en sus filas con Josefina Peralta (tres temporadas en La Liga Femenina) una de las debutantes más jóvenes en la élite del básquet nacional además de Violeta Saravia y Helena Traube que ya tuvieron minutos de acción en La Liga Femenina pasada.  <p>
    <p> Programación en el Estadio Ciudad:
Sábado 5 de julio:
16 Hs Municipalidad Luján de Cuyo vs Olímpico
18 Hs Quimsa vs Urquiza de San Juan
 <p>
    <p>Domingo 6 de Julio:
9 Hs Olímpico vs Urquiza
11 Hs Quimsa vs Municipalidad 
  <p>
    <p> 17 Hs Municipalidad vs Urquiza 
19 Hs Quimsa vs Olímpico  <p>
    <p> El valor de las entradas se fijó en $2000 <p>

   
    

    
  `
},
{
  id: 19,
  titulo: 'AGUSTÍN PÉREZ TAPIA NO SIGUE EN QUIMSA ',
  categoria: 'Jugadores',
  fecha: '4 Julio 2025',
  imagen: '/noticias/agustinpereztapia-nosigue.jpeg',
  contenido: `
    <p>El escolta oriundo de Neuquén terminó su vínculo con la Fusión. En su segundo paso por la institución promedió 11.1 puntos y 2 asistencias por La Liga y 13.6 tantos en la BCLAmericas. La institución agradece al jugador por su profesionalismo y le desea el mayor de los éxitos en su carrera.  <p>

    

    
  `
},
{
  id: 20,
  titulo: 'BRUNO SANSIMONI NO CONTINÚA EN QUIMSA',
  categoria: 'Jugadores',
  fecha: '7 Julio 2025',
  imagen: '/noticias/brunosansimoni-nosigue.jpeg',
  contenido: `
    <p>La Asociación Atlética Quimsa informa que el jugador Bruno Sansimoni no seguirá en el equipo de cara a la temporada 2025/26.  <p>
    <p>El base de 29 años oriundo de Olavarría integró el plantel profesional de la Fusión durante dos temporadas logrando la Súpercopa, Copa Súper 20 y la BCLAmericas 2023/24. En la pasada edición de La Liga promedió 6.4 puntos y 2.7 asistencias llegando a instancias de semifinales. 
La institución agradece a "Chule" por estos años juntos y le desea el mayor de los éxitos en su carrera  <p>

    

    
  `
},
{
  id: 21,
  titulo: 'LEANDRO RAMELLA SIGUE EN EL BANCO DE LA FUSIÓN ',
  categoria: 'Cuerpo Tecnico',
  fecha: '11 Julio 2025',
  imagen: '/noticias/leandroramella-sigue.jpeg',
  contenido: `
    <p>El entrenador marplatense tendrá su cuarta temporada en Quimsa. 
  <p>
    <p>La institución santiagueña y el entrenador de 50 años Leandro Ramella pactaron la continuidad de cara a la temporada 2025/26 que tendrá nuevamente al equipo en el plano Internacional. Será la 11° temporada en La Liga para el coach (cuarta con Quimsa) que cuenta con pasos por Peñarol, La Unión, Quilmes y San Martín además de trabajar en México y Uruguay. Hasta el momento con la Fusión logró cuatro trofeos para ser el más ganador en la historia del profesionalismo del club con La Liga 2022/23, la Súpercopa 2023, Copa Súper 20 del 2024 y la BCLAmericas 2023/24.  <p>
    <p>En la pasada temporada llevó al equipo a semifinales de La Liga y a playoffs en la BCLAmericas. <p>
    <p>Los números de Ramella en Quimsa: <p>
        <p>Por La Liga disputó 119 partidos con un saldo de 86 triunfos y 33 derrotas para un total de 150 encuentros al mando del equipo contando torneos internacionales y copas nacionales. <p>


    

    
  `
},
{
  id: 21,
  titulo: 'VOLVIÓ PARA QUEDARSE: BRANDON ROBINSON SIGUE EN QUIMSA PARA LA 2025/26',
  categoria: 'Jugadores',
  fecha: '16 Julio 2025',
  imagen: '/noticias/brandon-sigue.jpeg',
  contenido: `
    <p>El escolta nacido en Florida (USA) es el primer confirmado en el equipo dirigido por Leandro Ramella. 
  <p>
    <p> Será la sexta temporada con la camiseta de Quimsa para el extranjero de 36 años. Siendo el más ganador con dos BCLAmericas (siendo MVP), dos Copa Súper 20, una Súpercopa y La Liga 2022/23 para convertirse en el foráneo más goleador y ganador en la institución santiagueña.
En la pasada temporada de La Liga, donde el equipo llegó a semifinales, el ex Flamengo y Peñarol promedió 16 puntos, 4 rebotes y 2 asistencias.  <p>
   
        <p>El "Chef" llegó por primera vez a la Asociación Atlética Quimsa en la 2019/20 y tras su paso por Astros de Jalisco (México) retornó a la Fusión en el período de Pandemia. Luego de jugar en Brasil, Brandon tuvo su tercer paso en Quimsa y tras unos meses en Peñarol de Uruguay el escolta se sumó febrero de este año para llegar a su cuarto ciclo en el club santiagueño.<p>


    

    
  `
},
{
  id: 22,
  titulo: 'UN TUCUMANO EN SANTIAGO DEL ESTERO, SEBASTIÁN ORRESTA SE SUMA A QUIMSA ',
  categoria: 'Jugadores',
  fecha: '21 Julio 2025',
  imagen: '/noticias/orresta-nuevo.jpeg',
  contenido: `
    <p>El base llega a Quimsa de cara a la 2025/26 tras su paso por Fortaleza de Brasil.
  <p>
    <p> Sebastián Orresta (Base / 1.88 metros / 32 años / Tafí Viejo, Tucumán) se suma a la Asociación Atlética Quimsa para la temporada 2025/26. El armador viene de disputar la NBB de Brasil con la camiseta de Fortaleza donde promedió 9 puntos, 3.8 rebotes y 5 asistencias. También cuenta con pasos por Lanús,  Estudiantes de Concordia, Ferro y Gimnasia de Comodoro Rivadavia. Formó parte de la Selección mayor en las eliminatorias rumbo al Mundial 2023.
El tucumano dijo tras su fichaje “Muy contento y con mucha ilusión de sumarme a un equipo con historia y que siempre se está preparando para cosas importante.  <p>
   
        <p>Mi objetivo es seguir por la misma línea del club, pelear  y ser competitivo por todo lo que se juegue”.<p>


    

    
  `
},
{
  id: 23,
  titulo: 'LEONARDO LEMA SE SUMA A QUIMSA ',
  categoria: 'Jugadores',
  fecha: '23 Julio 2025',
  imagen: '/noticias/lema-nuevo.jpeg',
  contenido: `
    <p>El Alero de 27 años se suma a la Fusión de cara a La Liga 2025/26. El oriundo de La Pampa viene de jugar en Atenas de Córdoba.
  <p>
    <p> Leonardo Lema (Alero / 2.03 metros / 27 años / General Pico, La Pampa) es el nuevo refuerzo de Quimsa de cara a la 2025/26. En la pasada temporada de La Liga promedió 12.6 puntos (40% triples) y 6.6 rebotes con la camiseta de Atenas. También cuenta con paso por São José (Brasil), Olímpico, Instituto, Unión, Defensor Sporting (Uruguay), Nacional (Uruguay) e Independiente de General Pico. Con la selección mayor debutó en 2020 en un partido clasificatorio a la Americup. <p>
   
        <p>Lema sostuvo tras ser confirmado “Estoy muy feliz y entusiasmado por esta oportunidad en un club tan importante en nuestra Liga como es Quimsa que todos los años se arma para lograr cosas importantes, voy a dar todo de mí para conseguir los objetivos que nos propongamos como equipo”.<p>


    

    
  `
},
{
  id: 24,
  titulo: 'SIGUE EL ARMADO DE LA FUSIÓN, MATÍAS SOLANAS REGRESA AL BÁSQUET ARGENTINO PARA VESTIR LA CAMISETA DE QUIMSA',
  categoria: 'Jugadores',
  fecha: '25 Julio 2025',
  imagen: '/noticias/solanas-nuevo.jpeg',
  contenido: `
    <p>El perimetral su suma luego de jugar dos temporadas en Brasil para el Unifacisa. 
  <p>
    <p> Matías Solanas (Escolta / 26 años / 1.93 metros / Paraná, Entre Ríos) es el nuevo jugador de Quimsa de cara a la temporada 2025/26 que tendrá al equipo santiagueño compitiendo en el ámbito nacional e internacional. "Matute" llega de dos años con Unifacisa en la NBB donde promedió en la pasada competencia 10.4 puntos y 3.2 asistencias, mientras que en nuestro país jugó en San Martín de Corrientes, La Unión de Colón, Talleres de Paraná y Sionista además de un par de pasos por el baloncesto de Colombia. 
Solanas formó parte de las juveniles de la Selección Argentina y debutó en la mayor en febrero del 2021 en los clasificatorios a la Americup. <p>
   
        <p>“Muy contento con esta oportunidad de representar a un club tan grande como Quimsa. Con ilusión y ganas de arrancar para dejar al equipo en lo más alto y que sea una gran temporada”.<p>


    

    
  `
},
{
  id: 25,
  titulo: 'DIEGO COLLOMB REGRESA A QUIMSA',
  categoria: 'Jugadores',
  fecha: '27 Julio 2025',
  imagen: '/noticias/collomb-nuevo.jpeg',
  contenido: `
    <p>El base de 20 años retorna a la Fusión luego de su paso por San Lorenzo. 
  <p>
    <p> Diego Collomb (Base / 20 años / 1.92 metros / Esperanza, Santa Fe) surgió en el club Almagro de Esperanza y vistió la camiseta de las selecciones nacionales formativas donde destaca el 5° puesto en el Mundial U19. Con Quimsa jugó La Liga de Desarrollo y tuvo participación en el plantel superior. Viene de disputar la 2024/25 con San Lorenzo donde promedió 8.6 puntos y 2.3 asistencias. <p>
   
        <p>“Muy contento con la oportunidad  de volver a representar la camiseta de la fusión. Con muchas ganas de arrancar y dejar en lo más alto a un club tan grande como Quimsa”<p>


    

    
  `
},
{
  id: 26,
  titulo: 'DIEGO FIGUEREDO LLEGA A QUIMSA ',
  categoria: 'Jugadores',
  fecha: '30 Julio 2025',
  imagen: '/noticias/figueredo-nuevo.jpeg',
  contenido: `
    <p>El experimentado base retornó a La Liga el año pasado con Riachuelo y se suma a la Fusión para los compromisos nacionales e internacionales de la 2025/26.

  <p>
    <p> Diego Figueredo (Base / 33 años / 1.85 metros / Córdoba) llega a la Asociación Atlética Quimsa luego de vestir la camiseta de Riachuelo de La Rioja la pasada temporada donde promedió 15.3 puntos, 4.7 rebotes y 4.1 asistencias. 
El oriundo de Córdoba cuenta con un gran paso por el básquet brasileño con Sao José, Flamengo y Corinthians, además de jugar en Plateros de Fresnillo (México) y Titanes de Barranquilla (Colombia). En nuestro país jugó en Ciclista, Sport Club, Ferro, Argentino, Libertad entre otros clubes. <p>
   
        <p>“Estoy muy feliz de sumarme a un proyecto tan grande como el de Quimsa. Un club que siempre tiene objetivos importantes. 
Va ser un gran año para todos, ya quiero que nos encontremos para empezar a entrenar y poder construir el equipo que deseamos todos”.<p>


    

    
  `
},
{
  id: 27,
  titulo: 'OTRA CONTINUIDAD EN LA FUSIÓN: NICOLÁS ROMANO SIGUE EN QUIMSA ',
  categoria: 'Jugadores',
  fecha: '30 Julio 2025',
  imagen: '/noticias/romano-continua.jpeg',
  contenido: `
    <p>El Ala Pivot será parte del plantel de cara a la temporada 2025/26 que tendrá a la Fusión con participación nacional e internacional. 

  <p>
    <p> Nicolás Romano (Ala pivot / 2 mts / 37 años / Junín) tendrá su cuarta temporada con la camiseta de Quimsa. Su primera etapa fue entre 2015 y 2017 para retornar en la edición 2024/25. En La Liga viene de promediar 11.1 puntos y 4.7 rebotes. <p>
   
        <p>Hasta el momento el entrenador Leandro Ramella cuenta con Sebastián Orresta, Diego Figueredo, Diego Collomb, Matías Solanas, Leonardo Lema y Nicolás Romano.

“Estoy muy feliz y muy agradecido de poder estar una temporada más en Quimsa y en Santiago del Estero.
Los objetivos serán poner a Quimsa donde pertenece, en lo más alto”.<p>


    

    
  `
},
{
  id: 28,
  titulo: 'REFUERZO DE JERARQUÍA EN LA PINTURA PARA QUIMSA, JEROME MEYINSSE SE SUMA A LA FUSIÓN.',
  categoria: 'Jugadores',
  fecha: '8 agosto 2025',
  imagen: '/noticias/jerome-continua.jpeg',
  contenido: `
    <p>El experimentado pivot de 36 años llega a Quimsa. Cuenta con paso por San Lorenzo , Atenas y viene del básquet israelí. 

  <p>
    <p>Jerome Dieu Donne Meyinsse (Louisiana, Estados Unidos / Pivot / 36 años / 2.08 metros) es el nuevo jugador de la Asociación Atlética Quimsa. El interno viene de jugar la pasada temporada el Ironi BC de Israel donde promedió 8.1 puntos y 4.5 rebotes. 

Campeón de La Liga con Regatas y San Lorenzo también estuvo en 9 de Julio, Estudiantes, Sionista y Atenas. En el exterior logró campeonatos con Flamengo de Brasil y jugó en Trotamundos (Venezuela), Aguacateros (México), Ironi (Israel), Sendai (Japón) y Mets de Guaynabo (Puerto Rico).<p>
   
        <p>“Quiero agradecer a Quimsa por darme la oportunidad de volver a Argentina. Estoy muy feliz de volver al país donde he jugado la mayor parte de mi carrera y sobre todo de unirme a un equipo con tanta historia como es Quimsa. Estoy acá para intentar ganar todas las competencias en las que participemos. Me alegra poder trabajar con caras conocidas y estoy emocionado por conocer a otras nuevas”.<p>


    

    
  `
},
{
  id: 29,
  titulo: 'QUIMSA ESTÁ DE FESTEJO, SE CUMPLEN 36 AÑOS DE LA FUSIÓN ',
  categoria: 'Jugadores',
  fecha: '12 agosto 2025',
  imagen: '/noticias/quimsa-festejo.jpeg',
  contenido: `
    <p><p><strong>QUIMSA ESTÁ DE FESTEJO, SE CUMPLEN 36 AÑOS DE LA FUSIÓN</strong></p>

<p>Este miércoles 13 de agosto, la Asociación Atlética Quimsa cumple 36 años de vida institucional. Un recorrido por los hitos de un club que, desde la Madre de Ciudades, llegó al primer plano mundial. Se tiene pactada una misa en la Catedral desde las 20 horas en conmemoración del aniversario.</p>

<p><strong>13 de agosto de 1989:</strong> La idea de fusionarse se hace realidad. Nace la Asociación Atlética Quimsa de la unión de Inti Club, Estudiantes Unidos y Santiago BBC.</p>

<p><strong>1997/98:</strong> Tras grandes campañas en el ámbito local y tomando protagonismo en los regionales (Ex Liga "C"), la institución obtiene la posibilidad de ascender a la Liga B (Tercera categoría a nivel nacional).</p>

<p><strong>2000:</strong> El primero de febrero iniciaba el patín artístico en la institución de calle Independencia, bajo la dirección de la Lic. Florencia Cella, quien iniciaba un proyecto que continúa a la fecha.</p>

<p><strong>2001:</strong> En el mes de septiembre, asume al frente del club Gerardo Montenegro, brindando soluciones a las deudas de la entidad y edificando bases sólidas para los siguientes exitosos años. Al día de hoy, continúa al cargo tras más de 20 años, siendo uno de los dirigentes más ganadores del país.</p>

<p><strong>2001/02:</strong> Un equipo en su mayoría conformado por santiagueños y dirigido por "Cacho" Banegas lograba el ascenso al TNA al derrotar en el mano a mano a Olimpia.</p>

<p><strong>2004/05:</strong> La Fusión disputa su primera definición por el ascenso a la Liga Nacional. No pudo ante Alianza La Unión de Formosa, pero los santiagueños ya estaban en los primeros planos nacionales del básquet.</p>

<p><strong>2005/06:</strong> Un frío primero de mayo en Núñez se tornó caluroso cuando el equipo de Marcelo Richotti y Miguel Cortijo superaba a Obras Sanitarias y lograba el ascenso a la Liga Nacional, desatando la alegría del pueblo santiagueño.</p>

<p><strong>2008:</strong> El primero de febrero, el equipo de Fabio Demti lograba un doble récord personal al golear 125-83 a Gimnasia de Comodoro Rivadavia en el Ciudad, con 26 puntos de Cleotis Brown, marcando la máxima de puntos de la Fusión en sus 17 años en la élite, además de la mayor diferencia (+42).</p>

<p><strong>2007/08:</strong> La Asociación Atlética Quimsa lograba jugar su primera final por el título de Liga, cayendo ante el equipo del momento, Libertad de Sunchales. En su segunda temporada, la Fusión lograba clasificarse a torneos internacionales.</p>

<p><strong>2009:</strong> El 12 de marzo, llegaba la primera final internacional para los dirigidos por Carlos "Negro" Romano. En un Estadio Ciudad con más de 6000 espectadores, la Fusión caía en un dudoso final ante Flamengo de Brasil por 98-96. Quimsa había llegado a la final invicto, ganando sus cinco partidos.</p>

<p><strong>2009:</strong> La revancha por la Sudamericana se daría el 19 de noviembre nuevamente en un colmado Estadio Ciudad, donde la Fusión se imponía 87-77 sobre Libertad de Sunchales, con 29 puntos de Julio Mázzaro, logrando su primer título internacional.</p>

<p><strong>2009:</strong> El 4 de octubre, Quimsa se consagró campeón de la Copa Argentina, al quedarse con el cuadrangular final disputado en Trelew, tras vencer a Gimnasia de Comodoro Rivadavia, Sionista de Paraná, y aunque perdió con Peñarol de Mar del Plata, le alcanzó para consagrarse en el triple empate.</p>

<p><strong>2010:</strong> Un 15 de enero debutaba en el plantel de Liga Nacional un jovencito de Colonia Dora, Gabriel Deck, formado en el club y que luego ganaría la doble corona del 2014/15 (Súper 8 y Liga). En su paso por el club jugó siete temporadas con 205 partidos.</p>

<p><strong>2014:</strong> Entre el 8 de octubre de 2014 y el 6 de enero de 2015, Quimsa logró el récord de LNB al hilvanar 17 triunfos consecutivos (20 si se cuentan las victorias del Súper 8).</p>

<p><strong>2014:</strong> El equipo de Silvio Santander obtenía el Súper 8 en Santiago del Estero tras imponerse 91-80 sobre Obras Sanitarias el 20 de diciembre, con "Penka" Aguirre como figura de la conquista.</p>

<p><strong>2015:</strong> Quimsa obtenía la LNB, el 15 de julio, tras el infartante 70-68 a Gimnasia en Comodoro Rivadavia, para quedarse con la serie 4-2. Los de Silvio Santander ganaron la liga de comienzo a fin, teniendo como figuras a Nicolás Aguirre, Robert Battle, Diego García y el juvenil Gabriel Deck.</p>

<p><strong>2016:</strong> En octubre, Quimsa se consagró Campeón de la Liga Nacional B de Cestoball Femenino, que se llevó a cabo en Salta, tras ganarle la final a Náutico Hacoaj por 96-89.</p>

<p><strong>2018:</strong> El 13 de mayo, se lograba la primera estrella del femenino, las fusionadas dirigidas por "Pipio" Pedemonte le ganaban en suplementario a Obras Sanitarias por 75-74.</p>

<p><strong>2018:</strong> El 18 de mayo, Quimsa se consagró campeón de La Liga de Desarrollo 2017-2018, al vencer 94-77 a Comunicaciones, en la final del Final 4. José Montero fue el MVP en el estadio Ciudad.</p>

<p><strong>2018:</strong> El 14 de septiembre, se hace oficial la formación de "Quimsa Solidario", el plan para mejorar, desarrollar y acompañar a los barrios, ciudades y a toda la provincia. El proyecto lleva más de cincuenta acciones solidarias y sociales.</p>

<p><strong>2018:</strong> El 22 de diciembre, en un Estadio Ciudad colmado, los de Silvio Santander obtenían el Súper 20 ante San Lorenzo por 76-70, con Courtney Fells inspirado al anotar 26 puntos.</p>

<p><strong>2019:</strong> El vóley del club logra el campeonato local en mayores masculino, y más tarde, los trofeos de las ligas Sub16 y Sub18 del femenino en 2021/22.</p>

<p><strong>2019:</strong> El 21 de febrero, la rama femenina conquistaba la Supercopa al superar a Berazategui 74-64, obteniendo el boleto al Interligas, donde días más tarde, disputó el trofeo ante Vera Cruz Campinas de Brasil.</p>

<p><strong>2019:</strong> El 13 de julio, obtenía su segunda Liga Nacional Femenina, en un partido de 55 minutos, derrotando a Vélez por 108-99.</p>

<p><strong>2019:</strong> El 13 de agosto, durante el 30° aniversario, se retiran las camisetas de Miguel Cortijo, Gabriel Deck, Fernando "Frente" Small y Nicolás "Penka" Aguirre.</p>

<p><strong>2019:</strong> Llegaba un título en la rama 3x3 masculina, logrando trofeos en todas las competencias de la AdC (Masculino, Desarrollo, 3x3 y Femenino), el 25 de agosto, con Sebastián Lugo como MVP, levantando la copa en Villa María, Córdoba, tras el 21-16 sobre Regatas.</p>

<p><strong>2020:</strong> El 30 de octubre, en el Antel Arena (Montevideo, Uruguay), tras eliminar en semifinales a San Lorenzo, Quimsa conquistaba América, superando a Flamengo (Brasil) 92-86 en la definición de la BCLA. Los de Sebastián González tuvieron a Brandon Robinson como MVP con sus 26 puntos.</p>

<p><strong>2021:</strong> El 6 de febrero, los de la Madre de Ciudades obtenían la medalla de plata en la Intercontinental al caer ante San Pablo Burgos de España (bicampeón europeo).</p>

<p><strong>2021:</strong> El 27 de febrero, el Súper 20 se convertía en el quinto trofeo nacional para el club, tras quedarse con el final four, imponiéndose a Instituto, Obras y San Martín. Mauro Cosolito realizó una gran tarea con 15 puntos en la definición.</p>

<p><strong>2021:</strong> El 29 de abril, Gabriel Alejandro Deck debutaba en la NBA con la camiseta de los Thunder ante los Pelicans, convirtiéndose en el primer santiagueño en lograr concretar el sueño NBA.</p>

<p><strong>2022:</strong> El 22 de enero, en Obras Sanitarias, la Fusión lograba su octava estrella al superar a San Lorenzo en la Supercopa por 88-69, con Eric Anderson como MVP.</p>

<p><strong>2022:</strong> El 12 de mayo, la jugadora santiagueña Andrea "Toti" Ledesma llega a su partido número 100 con la camiseta fusionada, siendo la tercera jugadora con más partidos en la historia de la liga nacional femenina.</p>

<p><strong>2023:</strong> El 16 de junio, llega la segunda Liga para la Fusión, doblegando en la serie final a Boca Juniors por 4-2. Bajo el mando de coach Ramella y con Eric Anderson como MVP, Quimsa festejaba su título con otra gran caravana para el recuerdo.</p>

<p><strong>2024:</strong> El 15 de marzo, se disputa una histórica final entre los dos equipos santiagueños. Quimsa y Olímpico definían la Copa Súper 20 que quedaba en manos de la Fusión, 97-80, ante el público santiagueño presente en el Vicente Rosales de La Banda.</p>

<p><strong>2024:</strong> Llegó la segunda BCL Americas para la institución santiagueña. El 14 de abril, la Fusión supera en un repleto Estadio Ciudad a Flamengo de Brasil por 92-80, con Brandon Robinson como MVP, para ser nuevamente el mejor equipo del continente.</p>

<p><strong>2024:</strong> Quimsa decía presente nuevamente en la FIBA Intercontinental Cup, el torneo más importante a nivel clubes FIBA, jugado en Singapur, donde la Fusión culminó en el sexto lugar.</p>

<p>En la actualidad, la institución se encamina a dos décadas en la élite del básquet argentino, donde sigue siendo protagonista, además de prepararse para una nueva participación internacional. También apuesta por seguir participando en la Liga Femenina y el trabajo con La Liga de Desarrollo y formativas de distintas disciplinas.</p>


  <p>
   
    
  `
},
{
  id: 30,
  titulo: 'TOMÁS CAVALLERO ES EL NUEVO JUGADOR DE QUIMSA',
  categoria: 'Jugadores',
  fecha: '15 agosto 2025',
  imagen: '/noticias/cavallero-nuevo.jpeg',
  contenido: `
    <p>El alero de 27 años regresa al básquet argentino luego de tres años para vestir la camiseta de la Fusión. 

  <p>
    <p>Tomás Cavallero (Alero / 27 años / 1.96 mts / Buenos Aires) debutó en Boca en la temporada 2016/17 y tuvo dos ciclos en el Xeneize ya que en su primera experiencia por Europa Adepla y Benicarló de España. En la 2022/23 regresó al viejo continente para jugar en el MBK Banik (Eslovaquia) y en Královští sokoli (Rep. Checa). Su últimas clubes fueron en el ascenso de Italia donde jugó con el Rieti, Juvecaserta y el Blacks Faenza donde promedió 14 puntos, 4.4 rebotes y 2.2 asistencias. <p>
   
        <p>De esta manera el equipo dirigido por Leandro Ramella cuenta con Diego Figueredo, Sebastián Orresta, Diego Collomb, Brandon Robinson, Matías Solanas, Leonardo Lema, Nicolás Romano, Jerome Meyinsse y Tomás Cavallero.

“Estoy muy  contento por este nuevo desafío. Agradezco a la institución por confiar en mí. Es un orgullo para mi representar un club con tanta historia como Quimsa y también volver a la Liga Nacional. Vamos a ser un gran año”.<p>


    

    
  `
},
{
  id: 40,
  titulo: 'QUIMSA RECIBE A LA LIGA FEDERAL FEMENINA ',
  categoria: 'Femenino',
  fecha: '15 agosto 2025',
  imagen: '/noticias/ligafederalfem.jpeg',
  contenido: `
    <p>Este sábado y domingo el Estadio Ciudad será sede del cuadrangular de La Liga Federal Formativa U17 femenina que tendrá a Quimsa como protagonista.


  <p>
    <p> Las dirigidas por Germán Brao reciben a Hindú (Córdoba), Bolívar (Carlos Paz) y Municipal Luján de Cuyo (Mendoza) en búsqueda de avanzar a la siguiente etapa del torneo organizado por la Confederación Argentina de Básquet. 
En el equipo fusionado aparecen figuras como Josefina Peralta, Helena Traube, Violeta Saravia y un nutrido grupo de jugadoras que ya debutaron en La Liga Femenina y comparten entrenos con el plantel superior.  <p>
   
        <p>Programación: 
Sábado 16 de agosto 
10 Hs Quimsa vs Municipalidad Luján de Cuyo
18 Hs Hindú vs Municipalidad
20 Hs Bolívar vs Quimsa
Domingo 17 de agosto
9 Hs Bolívar vs Municipalidad
11 Hs Hindú vs Quimsa 
17 Hs Bolívar vs Hindú<p>


    

    
  `
},
{
  id: 41,
  titulo: 'MARIANO MARCOS SE SUMA A LA FUSIÓN  ',
  categoria: 'Cuerpo Tecnico',
  fecha: '20 agosto 2025',
  imagen: '/noticias/marianomarcos.jpeg',
  contenido: `
    <p>El entrenador rosarino llega a Quimsa luego de tres años como coordinador de la C.A.B. 


  <p>
    <p>  Mariano Marcos integró durante diez años distintos cuerpos técnicos en la estructura de los seleccionados nacionales y cumplió durante más de tres años el rol de coordinador de selecciones formativas donde desarrolló distintos planes para la formación y captación de jugadores. 
En Quimsa ocupará el cargo de entrenador y coordinador de las categorías formativas brindando capacitaciones internas y siendo el nexo con el cuerpo técnico superior a cargo de Leandro Ramella.  <p>
        <p> Cuenta con pasos por Club Río Negro, Naútico Avellaneda de Rosario, Libertad, Española de Charata, El Coatí de Misiones además de estar al frente de seleccionados provinciales.   <p>
   
        <p>  
“Para mí es un paso muy importante llegar a una institución tan importante en el básquet argentino como en Quimsa, también estoy contento de poder seguir trabajando en formación y bueno la idea es junto con los colegas que están en el club poder hacer un trabajo serio y responsable en cuanto a colaborar con la formación de los prospectos del club en su transición al profesionalismo y además la idea es coordinar las categorías menores para poder tener un trabajo ordenado y una filosofía de juego en todas las categorías del club”. <p>


    

    
  `
},
{
  id: 42,
  titulo: 'La Asociación Atlética Quimsa comenzó la pretemporada de cara a La Liga Nacional 2025/26 y La Liga Sudamericana. ',
  categoria: 'Cuerpo Tecnico',
  fecha: '25 agosto 2025',
  imagen: '/noticias/pretemporada1.jpeg',
  contenido: `
    <p>Este lunes en el Estadio Ciudad la Fusión cumplió con su primer entrenamiento rumbo a una nueva temporada. Al mando del entrenador Leandro Ramella y contando con la presencia del presidente Gerardo Montenegro y el manager Diego LoGrippo el plantel inició su camino en la 2025/26 que tendrá desafíos en el plano nacional e internacional. El plantel estuvo conformado por Diego Figueredo, Tomás Cavallero, Matías Solanas, Leonardo Lema, Sebastián Orresta, Diego Collomb, Nicolás Romano y los jóvenes que integran La Liga de Desarrollo mientras que se sumarán pronto Brandon Robinson y Jerome Meyinsse.


  <p>
   
    
  `
},
{
  id: 43,
  titulo: 'LAS VOCES DE QUIMSA EN LA PREVIA  DE UNA NUEVA TEMPORADA ',
  categoria: 'Equipo',
  fecha: '26 agosto 2025',
  imagen: '/noticias/voces.jpeg',
  contenido: `
    <p>Leandro Ramella, Diego Figueredo y Matías Solanas hablaron en el inicio de la pretemporada para la Fusión


  <p>
    <p>  El entrenador en jefe Leandro Ramella afronta su cuarta temporada al mando de Quimsa, el DT campeón de La Liga y BCLAmericas dijo "Es un grupo nuevo, nos estamos conociendo. Observé muchas ganas por parte de todos así que estamos contentos y con muchas expectativas. Por el momento iremos trabajando doble turno para sumar horas en lo conceptual al ser un grupo nuevo y a mitad de septiembre comenzar con los amistosos" además el marplatense agregó "Quimsa siempre apuesta a más, así que buscaremos mejorar lo que hicimos la temporada pasada que no es poca cosa un tercer puesto, pero vamos a trabajar para lograrlo" cerró el entrenador con paso por Peñarol y Quilmes.  <p>
        <p> Por su parte el base Diego Figueredo que llega desde Riachuelo declaró "Contento por como me recibió la ciudad y el club. Estamos enfocados en construir un grupo dentro del equipo, luego el resto llegará solo. Es muy importante conocernos porque creo que tenemos lo necesario para pelear tanto La Liga como La Liga Sudamericana".    <p>
   
        <p>  Matías Solanas regresa al país luego de su paso por Brasil, el ex San Martín agregó "Muy contento por llegar a Quimsa, tengo grandes expectativas con poder competir en los torneos que nos toque. Tenemos un equipo con jerarquía así buscaremos lograr lo antes posible la química en el grupo. Llego con ganas de lograr cosas importantes con el club". <p>
        <p> Quimsa seguirá entrenando en el Estadio Ciudad con plantel reducido a la espera de la llegada de Brandon Robinson y Jerome Meyinsse. La Fusión dirá presente en una nueva edición de La Liga además de jugar La Liga Sudamericana con rivales y sede a confirmar.<p>


    

    
  `
},
{
  id: 44,
  titulo: 'El Departamento de Prensa de la Asociación Atlética Quimsa informa que a partir de este jueves se dará inicio al proceso de acreditaciones para la temporada 2025/2026',
  categoria: 'Prensa',
  fecha: '27 agosto 2025',
  imagen: '/noticias/prensa2025.jpeg',
  contenido: `
    <p>Los medios interesados deberán enviar los datos del personal (DNI, foto carnet digital, medio y función) y la solicitud al mail  quimsaacreditaciones@gmail.com. 

Los cupos para los distintos medios serán los siguientes:

Medios radiales hasta 3 cupos (incluyendo técnico).

Medios televisivos 2 cupos (incluyendo Cámara y notero).

Prensa escrita 2 cupos

Medios digitales 2 cupos a consideración (incluyendo fotógrafo) 

El pedido de acreditación no garantiza su aceptación.

¡Muchas gracias!


  <p>
    <p>  El día viernes 5/9 será hará el cierre de las acreditaciones ya que se mandarán a imprimir  <p>
        
    

    
  `
},
{
  id: 45,
  titulo: 'MARIANO MARCOS TRAS SU LLEGADA A QUIMSA',
  categoria: 'Cuerpo Tecnico',
  fecha: '28 agosto 2025',
  imagen: '/noticias/marianollegada.jpeg',
  contenido: `
    <p> El flamante entrenador de La Liga de Desarrollo y coordinador de la Fusión habló sobre su arribo a la institución.  <p>
   
        <p>  El ex coordinador de selecciones formativas de Argentina dijo "Llego a uno de los clubes más importantes del País, en el desarrollo de las formativas para seguir con el trabajo que vienen cumpliendo Marcelo Zanni y Cristian Suárez, buscar mejorar la técnica individual y la lectura de juego para cada integrante del plantel de La Liga de Desarrollo e involucrarme con las distintas categorías del club. Ver la manera de formar una especie de academia para los juveniles, que cada chico tenga la posibilidad de ir creciendo día a día y que sea un punto de referencia para este sector de Argentina" <p>
        <p> El Rosarino agregó "El objetivo será a largo plazo, seguir formando chicos que puedan estar presentes en distintos niveles, lo que no quita la posibilidad de ir mejorando día a día para competir de igual a igual contra cualquier equipo" cerró el entrenador que estará al mando de La Liga de Desarrollo 2025/26.<p>


    

    
  `
},
{
  id: 46,
  titulo: 'QUIMSA YA CONOCE A SUS RIVALES EN LA LIGA SUDAMERICANA',
  categoria: 'Liga Sudamericana',
  fecha: '2 septiembre 2025',
  imagen: '/noticias/ligasudamericana1.jpeg',
  contenido: `
    <p> La Asociación Atlética Quimsa compartirá grupo en San Pablo ante el local Corinthians, además de Importadora Alvarado de Ecuador y Defensor Sporting de Uruguay. 

Grupo A
Olimpia Kings (PAR) – Anfitrión 
Jorge Guzmán (ECU) 
Oberá (ARG) 
Baurú (BRA)
Fecha: 3 al 5 de octubre
Sede: Pilar, Paraguay 

Grupo B
Club Universitario de Sucre (BOL) – Anfitrión 
Ferro (ARG)
Vasco da Gama (BRA)
Motilones del Norte (COL) 
Fecha: 9 al 11 de octubre
Sede: Sucre, Bolivia 

Grupo C
Corinthians (BRA) – Anfitrión
Quimsa (ARG)
Defensor Sporting (URU) 
Importadora Alvarado (ECU) 
Fecha: 24 al 26 de octubre 
Sede: São Paulo, Brasil 

Grupo D
Deportivo San José (PAR) – Anfitrión Regatas Corrientes (ARG)
Pinheiros (BRA) 
CDC Leones (CHI) 
Fecha: 27 al 29 de octubre 
Sede: Asunción, Paraguay. 

Los dos mejores equipos de cada grupo avanzarán a nuevos cuadrangulares, para luego obtener los clasificados al Final 4. 

Esta será la Liga Sudamericana número 28. El campeón de 2024 fue el club Nacional de Uruguay mientras que la Fusión levantó el título en la edición II del 2009.  <p>
   

    

    
  `
},
{
  id: 47,
  titulo: 'GERMÁN BRAO SIGUE AL FRENTE DE QUIMSA EN LA LIGA FEMENINA 2025/26',
  categoria: 'Liga Femenina',
  fecha: '4 septiembre 2025',
  imagen: '/noticias/germanbrao1.jpeg',
  contenido: `
    <p> El entrenador santiagueño seguirá al mando del primer equipo de la Fusión de cara a una nueva edición de La Liga Femenina. 
  <p>
   
        <p>  Germán Brao (34 años, Santiago del Estero) fue confirmado por una temporada más al mando de Quimsa en La Liga Femenina. El entrenador está a cargo de la rama femenina en la institución además de coordinar las selecciones santiagueñas.  <p>
        <p> Tras abrocharse su continuidad dijo "Es muy satisfactorio de mi parte que el club renueve en mí su voto de confianza" también agregó "Las expectativas son buenas para esta temporada atractiva donde se suman clubes. Vamos a mantener la base del último equipo y trabajaremos para encontrar nuestra mejor versión".<p>
  <p> Quimsa estará confirmado su plantilla en los próximos días.
  <p>

    

    
  `
},
{
  id: 48,
  titulo: 'JEROME MEYINSSE "ESTOY AQUÍ PARA AYUDAR AL EQUIPO Y SUMAR MI EXPERIENCIA"',
  categoria: 'Jugadores',
  fecha: '6 septiembre 2025',
  imagen: '/noticias/jerome2.jpeg',
  contenido: `
    <p> El flamante refuerzo de Quimsa habló tras sus primeros días en Santiago del Estero. La elección nuevamente por Argentina y las expectativas para una temporada que comienza en unas semanas. 
  <p>
   
        <p>  El oriundo de Louisiana, Estados Unidos llegó este viernes y tras unos días en el club dijo "Estoy muy contento y me siento cómodo desde el primer día porque tengo amigos con quien ya jugué, algunos más que otros. Estoy listo para comenzar, creo que va a ser una linda temporada, ahora hay que ponernos en forma y aprender como juega uno u otro" agregó "Lo conozco a Quimsa porque es protagonista, lo enfrenté varias veces y compartí equipo con Diego LoGrippo en Atenas, me interesa el proyecto de la institución y el gran trabajo que ya hicieron"  <p>
        <p> El ex Regatas y San Lorenzo detalló "Fue una decisión fácil retornar al básquet de Argentina porque ya conozco La Liga, la cultura y el idioma" además destacó "Queremos ganar nuevamente todos los títulos que ya consiguió el club, estoy aquí para ayudar al equipo en las competencias, aportar mi experiencia para volver a ganar" cerró el pivot de 36 años.<p>
  <p> Quimsa estará cumpliendo con estos días de entrenos en el Estadio Ciudad para luego trasladarse a Rosario donde tendrá un cuadrangular amistoso junto a Independiente, Instituto y Unión de cara al inicio de La Liga 2025/26.
  <p>

    

    
  `
},
{
  id: 49,
  titulo: 'CINCO QUE SIGUEN: BOGGETTI, CAMPOS,  ROJAS, ITURRE Y LEGUIZAMÓN EN LA FUSIÓN',
  categoria: 'Liga Femenina',
  fecha: '9 septiembre 2025',
  imagen: '/noticias/femenina2.jpeg',
  contenido: `
    <p> Las jugadoras santiagueñas están confirmadas para una nueva edición de La Liga Femenina. Comienza el armado del plantel de Germán Brao.  
  <p>
   
        <p> Lorena Campos (Alera / 26 años / 1.71 metros) fue una de las principales anotadores de la pasada temporada con 14.1 de promedio junto a 2.4 recuperos.

Lucía Boggetti (Escolta / 27 años / 1.65 metros) la oriunda de Monte Quemado tuvo una media de 8 puntos y 5 rebotes en la 2024/25.

María Emilia Rojas (Ala Pivot / 26 años / 1.70 metros) sumó 6 puntos con 46% en triples y 2 rebotes por partido en la temporada pasada. 

Agostina Leguizamón (Base / 25 años / 1.66 metros) dijo presente la 2024/25 llegando a semifinales de conferencia junto a la Fusión promediando 4.7 puntos y 1.6 asistencias. 

Rocío Iturre (Alera / 24 años / 1.68 metros) seguirá de cara a una nueva edición del torneo femenino. Viene de colaborar con 6.4 tantos y 4 rebotes por encuentro. <p>
  <p> Quimsa estará cerrando su plantel esta semana a la espera de comenzar una vez más La Liga Femenina, certamen que disputa de forma ininterrumpida desde su creación en 2017.
  <p>

    

    
  `
},
{
  id: 50,
  titulo: 'QUIMSA Y LA BANDERA SANTIAGUEÑA PARA LA 2025/26',
  categoria: 'Media Day',
  fecha: '11 septiembre 2025',
  imagen: '/noticias/mediaday1.jpeg',
  contenido: `
    <p> Esta temporada, Quimsa llevará con orgullo en su camiseta la bandera de Santiago del Estero, como un símbolo de identidad y pertenencia. La Bandera Provincial, con sus franjas rojo y celeste unidas por un blanco central, luce en su corazón el sol incaico y la espada de Santiago Apóstol a la cruz latina, representando historia, fe y tradición.
  <p>
   
        <p>  A lo largo de los años, la Asociación Atlética Quimsa siempre ha rendido homenaje a su tierra en la indumentaria, llevando íconos que identifican a los santiagueños: el Estadio Madre de Ciudades, el Puente Carretero, la Catedral Basílica y la figura de Mamantula . <p>
  <p> Hoy, al sumar la bandera, Quimsa vuelve a reflejar su profundo sentido de pertenencia con Santiago del Estero, tal como lo ha hecho cada vez que le tocó conquistar títulos nacionales e internacionales.
  <p>

    

    
  `
},
{
  id: 51,
  titulo: 'CHRISTIAN NEGRON, DE PUERTO RICO A SANTIAGO DEL ESTERO',
  categoria: 'Jugadores',
  fecha: '11 septiembre 2025',
  imagen: '/noticias/negron.jpeg',
  contenido: `
    <p> El interno de 26 años se suma a Quimsa de cara a las competencias de la temporada 2025/26. Llega tras su paso por Leones de Ponce en Puerto Rico 

  <p>
   
        <p>  Christian Negron (Ala Pivot / 2.01 metros/ 26 años / Puerto Rico) cuenta con formación por el básquet universitario de la NCAA con Loyola Ramblers para luego pasar al profesionalismo con Leones de Ponce de Puerto Rico y Panteras de Aguascalientes en México. Además vistió la camiseta de su país en las clasificatorias a la Americup 2025. <p>
  <p> “Estoy muy emocionado de jugar en Quimsa este año. Sé que el club ha competido en un alto nivel en estos años y las expectativas son ganar.
Será un gran desafío, pero confío en el trabajo y la preparación que pongo día a día”.
  <p>

    

    
  `
},
{
  id: 52,
  titulo: 'QUIMSA ABRIRÁ SU TEMPORADA DE LA LIGA ANTE INSTITUTO EN EL CIUDAD',
  categoria: 'Partidos',
  fecha: '11 septiembre 2025',
  imagen: '/noticias/primerpartido.jpeg',
  contenido: `
    <p> La Asociación de Clubes dió a conocer los primeros partidos de la 2025/26. La Liga comenzará el miércoles 24 con Boca ante Racing de Chivilcoy y la Fusión jugará ante Instituto el jueves 25 del corriente.

  <p>
   
        <p>  La Asociación Atlética Quimsa jugará por 20° temporada al hilo La Liga y tendrá como primeros duelos Instituto (25/9) y Argentino (28/9) en condición de local.  <p>
  <p>En octubre llegará la primera gira para los dirigidos por Leandro Ramella donde visitarán a Obras (lunes 6), Peñarol (miércoles 8) también:
Martes 14/10 Quimsa vs Atenas
Martes 21/10 Quimsa vs Racing Chivilcoy 
Miércoles 29/10 Quimsa vs Independiente 
Entre el 24 y 26 de octubre Quimsa jugará en Brasil por su grupo de la Liga Sudamericana de Clubes.
  <p>

    

    
  `
},
{
  id: 53,
  titulo: 'QUIMSA VENCIO 101/97 a Union de Santa Fe',
  categoria: 'Partidos',
  fecha: '12 septiembre 2025',
  imagen: '/noticias/quimsaunion2.jpeg',
  contenido: `
    <p> La Asociación Atlética Quimsa venció 101/97 a Unión de Santa Fe y jugará mañana la final de la Copa Turismo Carey que se lleva a cabo en Rosario.
  <p>
   
        <p>  La Fusión tuvo esta noche su primer ensayo formal con un intenso partido ante el Tatengue, el equipo de Ramella en el primer tiempo pudo sacar una ventaja de 10 puntos pero Unión con la experiencia de Franco Balbi y sus nuevos refuerzos emparejó el juego, Quimsa contó con una gran noche de Romano (18 puntos) y el debutante Leonardo Lema (15 puntos).  <p>
  <p>También tuvieron una destacada actuación Tomás Cavallero y Diego Figueredo.
Mañana el equipo santiagueño enfrentará desde las 20:30 a Instituto de Córdoba para definir al ganador del cuadrangular.
  <p>

    

    
  `
},
{
  id: 54,
  titulo: 'QUIMSA CAYO 104/90 ante Instituto ',
  categoria: 'Partidos',
  fecha: '13 septiembre 2025',
  imagen: '/noticias/quimsainstituto2.jpeg',
  contenido: `
    <p> Quimsa cayó 104/90 ante Instituto en la final de la Copa Turismo Carey.
Nicolás Romano y Jerome Meyinsse los goleadores con 19 puntos.
  <p>
   
        <p> El equipo que dirige Leandro Ramella tuvo su segundo partido preparatorio y el próximo fin de semana tendrá una serie de amistosos en Córdoba para llegar de la mejor manera al debut en la Liga Nacional ante Instituto. <p>
  <p>El martes arribará a la provincia el portorriqueño Christian Negron y Ramella viajará el fin de semana con equipo completo.
  <p>

    

    
  `
},
{
  id: 55,
  titulo: 'Brandon Robinson y Nicolás Romano serán los capitanes de Quimsa en esta temporada',
  categoria: 'Capitanes',
  fecha: '14 septiembre 2025',
  imagen: '/noticias/capitanes25y26.jpeg',
  contenido: `
    <p> Brandon Robinson y Nicolás Romano serán los capitanes de Quimsa en esta temporada
  <p>
   
       
    

    
  `
},
{
  id: 56,
  titulo: 'QUIMSA SE PONE A PUNTO PARA UNA NUEVA EDICIÓN DE LA LIGA FEMENINA ',
  categoria: 'Femenino',
  fecha: '15 septiembre 2025',
  imagen: '/noticias/femenino2.jpeg',
  contenido: `
    <p> Tras la confirmación de Lara Gramajo y Clara Della Rosa, las dirigidas por Germán Brao se preparan para participar de La Conferencia Norte de La Liga Femenina. 
  <p>

   <p> La alera Lara Gramajo y la pivot Clara Della Rosa se suman a la lista de santiagueñas para una nueva edición de La Liga Femenina, torneo donde Quimsa posee asistencia perfecta desde su creación en 2017 y cuenta con dos títulos. 
  <p>

   <p> En el equipo santiagueño ya aseguraron su continuidad Emilia Rojas, Lucía Boggetti, Rocío Iturre, Agostina Leguizamón, Lorena Campos, Lara Gramajo, Clara Della Rosa y un nutrido grupo de juveniles que tuvieron participación en las ediciones pasadas. 
<p>


 <p> Con Germán Brao como DT y Alvaro Miana como Preparador Físico, el equipo siguió entrenando luego del cierre de la temporada 2024/25 y en esta edición formará parte de una histórica competencia con récord de 18 equipos. 
<p>


<p> El plantel seguirá entrenando en el Estadio Ciudad de manera diaria combinando entrenos físicos como tácticos.
<p>

   
       
    

    
  `
},
{
  id: 58,
  titulo: 'GERMÁN BRAO: "AGRADECIDO AL CLUB POR APOSTAR EN MÍ Y EN TODO EL GRUPO DE TRABAJO" ',
  categoria: 'Femenino',
  fecha: '19 septiembre 2025',
  imagen: '/noticias/germanbrao4.jpeg',
  contenido: `
    <p> El entrenador de Quimsa habló en la previa de una nueva edición de La Liga Femenina, refiriéndose a la pretemporada, al equipo y a la confianza del club por su continuidad.

   <p> La alera Lara Gramajo y la pivot Clara Della Rosa se suman a la lista de santiagueñas para una nueva edición de La Liga Femenina, torneo donde Quimsa posee asistencia perfecta desde su creación en 2017 y cuenta con dos títulos. 
  <p>

   <p> El coach santiagueño expresó:
"Una vez finalizada la temporada anterior, nos pusimos a diagramar junto al cuerpo técnico para llegar de la mejor manera al inicio de este nuevo torneo. Las jugadoras trabajan con una intensidad muy alta, por lo que cumplimos con las expectativas".
<p>


 <p> Además, el coordinador del básquet femenino del club agregó:
"Las primeras semanas apuntamos al acondicionamiento físico, en los últimos días fuimos sumando volumen de juego y la próxima semana tendremos un partido amistoso para ir corrigiendo los aspectos tácticos".
<p>


<p> Será el segundo torneo de Brao al mando de Quimsa en La Liga Femenina, y el DT destacó:
"Me encuentro agradecido al club por apostar tanto en mí como en todo el grupo de trabajo; siento que esto es un plus. Estoy contento por esta oportunidad de poder seguir plasmando este proyecto".

Quimsa continuará con los entrenamientos la próxima semana, cuando disputará un amistoso con el objetivo de llegar en óptimas condiciones al inicio de La Liga Femenina 2025/26, que contará con un récord histórico de 18 equipos.
<p>

   
       
    

    
  `
},
{
  id: 57,
  titulo: 'DIEGO FIGUEREDO "HAY COSAS EN DEFENSA POR MEJORAR PERO ES CUESTIÓN DE RODAJE Y QUÍMICA"',
  categoria: 'Jugadores',
  fecha: '17 septiembre 2025',
  imagen: '/noticias/diegof2.jpeg',
  contenido: `
    <p> El armador cordobés de La Fusión habló luego de los primeros amistosos y en la previa al inicio de La 2025/26.
  <p>

   <p> Luego de los amistosos ante Unión e Instituto el base destacó "Nos dejaron buenas sensaciones a nivel grupal, nos sirvió para conocernos. Hay cosas en defensa por mejorar pero es cuestión de rodaje y Química, en ofensiva tenemos muchas opciones por calidad de jugadores y gol en sus manos" también agregó "Fueron buenas pruebas ante rivales que serán competitivos en La Liga así que nos quedamos con un balance positivo".
  <p>

   <p> El ex Riachuelo habló sobre el aporte de los extranjeros en el equipo "Es muy importante que los foráneos se encuentren con tiempo en la pretemporada, eso ayuda para conocernos y adaptarlos a nuestro estilo de juego. Por suerte tenemos dos extranjeros que conocen muy bien la competencia " y sobre los amistosos en Bell Ville dijo "La idea es mejorar nuestro trabajo como equipo y seguir compitiendo a falta de poco para el inicio de La Liga" resaltó el armador de 33 años.
<p>


 

   
       
    

    
  `
},
{
  id: 59,
  titulo: ' QUIMSA SE QUEDÓ CON SU ÚLTIMO AMISTOSO DE PRETEMPORADA',
  categoria: 'Equipo',
  fecha: '20 septiembre 2025',
  imagen: '/noticias/ultimoamistoso4.jpeg',
  contenido: `
    <p> La Fusión se impuso ante Atenas de Córdoba en Bell Ville 86/73 en su último encuentro de carácter amistoso. Lema sumó 13 puntos para el equipo santiagueño que debutará el jueves como local ante Instituto. 
  <p>
 <p>
   <p> Quimsa disputó en Bell Ville su último duelo previo al inicio de La Liga 2025/26. En un primer tiempo de alto voltaje, el santiagueño se fue al entretiempo arriba 50/41 con Figueredo sumando y asistiendo para ser el protagonista. En el complemento Atenas se puso a cinco, pero la Fusión logró acomodarse en defensa para luego imponerse 86/73 con Lema y Sonalas goleadores con 13 y 11 tantos respectivamente, además de los 10 de Figueredo, Robinson y Meyinsse.

   <p>  Los dirigidos por Leandro Ramella tendrán un comienzo de temporada exigente con su debut en La Liga el jueves como local ante Instituto de Córdoba además de no perder de vista su participación en La Liga Sudamericana el próximo mes en Brasil.
<p>


 

   
       
    

    
  `
},
{
  id: 60,
  titulo: ' QUIMSA PRESENTE EN LA LIGA NACIONAL DE CESTOBALL EN GENERAL PICO ',
  categoria: 'Cestoball',
  fecha: '20 septiembre 2025',
  imagen: '/noticias/cestoball4.jpeg',
  contenido: `
    <p> Las Fusionadas son las campeonas del torneo local de Cestoball y representarán a Santiago del Estero en La Liga Nacional de Clubes en La Pampa.
  <p>

   <p> Quimsa integra el grupo D junto a G.E.V.P. de Capital Federal, Hijitus de San Luis y Regatas Corrientes. Donde los dos mejores elencos avanzarán a los cuartos de final. 
En la previa la jugadora Sofía Batule declaró "Nos preparamos desde inicio de año, el primer objetivo fue ganar el torneo local para clasificar y luego aumentar las expectativas con esta Liga Nacional". 
El plantel dirigido por Marcía González está conformado por Yaneth Alvarez, Celeste Corvalán, Luján Torres, Lucía Batule, Brenda Infante, Mara Luna, Sofía Orellana, Laura Peralta, Sofía Batule, Belén Paz, Abril Corvalán, María Moreno y Dalma Luna. 
 <p>
   <p> El torneo se jugará del 24 al 28 del corriente en General Pico, La Pampa y los partidos definitorios podrán verse por el Canal de YouTube de la Confederación Argentina de Cestoball.
<p>


 

   
       
    

    
  `
},
{
  id: 61,
  titulo: 'QUIMSA ABRE SU TEMPORADA RECIBIENDO A INSTITUTO EN EL CIUDAD ',
  categoria: 'Equipo',
  fecha: '24 septiembre 2025',
  imagen: '/noticias/quimsadebut4.jpeg',
   contenido: `
    <p>La Fusión debuta en La Liga 2025/26 frente al equipo cordobés a partir de las 21:30 horas de este jueves.</p>
    <p>Quimsa comienza una nueva edición de La Liga frente a Instituto de Córdoba. Los dirigidos por Leandro Ramella tuvieron cuatro amistosos previos para irse conociendo en un plantel que mantuvo solamente a Brandon Robinson y Nicolás Romano además del retorno de Diego Collomb sumando a los refuerzos de Sebastián Orresta, Christian Negron, Matías Solanas, Tomás Cavallero, Jerome Meyinsse, Leonardo Lema y Diego Figueredo. Su rival viene de lograr el subcampeonato la pasada temporada y Diego Vadell es su nuevo entrenador contando con refuerzos como Gastón Whelan y Vicente Garello además de mantener a Leandro Vildoza, Nicolás Copello y Javier Saiz.</p>
    <p>El encuentro comenzará a las 21:30 horas con el arbitraje de Fabricio Vito, Roberto Smith y Ariel Rosas. La Liga de Desarrollo tendrá su debut desde las 17:30 horas también en el Estadio Ciudad.</p>
    <p><strong>PRECIO ENTRADAS 2025-2026</strong><br/>
    Este Baja: $13.000<br/>
    Este Alta: $7.000<br/>
    Oeste: $9.000<br/>
    Norte: $9.000</p>
  `
},
{
  id: 62,
  titulo: 'QUIMSA TIENE RIVAL PARA LOS CUARTOS DE FINAL: ENFRENTARÁ A INSTITUTO POR UN BOLETO A SEMIS',
  categoria: 'Equipo',
  fecha: '7 mayo 2026',
  imagen: 'https://i.ibb.co/rj6S0v0/quimsa.jpg',
  contenido: `
    <p>El conjunto cordobés eliminó a Obras en la reclasificación y será rival de la Fusión en cuartos de final. La serie comenzará este sábado en el Ciudad.</p>

    <p><strong>Historial:</strong> Se enfrentaron en 33 oportunidades por La Liga, con 20 triunfos para Instituto y 13 para Quimsa. Esta temporada el conjunto cordobés le ganó a la Fusión 73/72 en el Estadio Ciudad, mientras que los dirigidos por Victoriano lo ganaron en Córdoba 79/78.</p>

    <p>En playoffs definieron al campeón 2021/22 con la consagración de Instituto 3/2 en quinto juego con los libres de Cuello sobre el final para ganarlo 85/84.</p>

    <p>En la temporada 2017/18 se enfrentaron en cuartos de final donde Instituto se quedó con la serie 3 - 1.</p>

    <p>Ambos equipos fueron protagonistas en los últimos torneos nacionales e internacionales y esta llave de cuartos de final promete un semifinalista que aspire a ser campeón. Instituto perdió las últimas temporadas ante Boca mientras que Quimsa quedó eliminado en semis ante el Xeneize la pasada temporada.</p>

    <p><strong>PROGRAMACIÓN:</strong><br/>
    JUEGO 1: Sábado 9 en el Estadio Ciudad<br/>
    JUEGO 2: Lunes 11 en el Estadio Ciudad<br/>
    JUEGO 3: Jueves 14 en el Ángel Sandrín<br/>
    *JUEGO 4: Sábado 16 en el Ángel Sandrín<br/>
    *JUEGO 5: Martes 19 en el Estadio Ciudad</p>

    <p><em>*En caso de ser necesario.</em></p>

    <p>El ganador de la serie se enfrentará en semifinales a Oberá o Boca.</p>
  `
},

{
  id: 63,
  titulo: 'JOSEFINA PERALTA, CLAVE EN EL BRONCE DE ARGENTINA EN EL 3x3',
  categoria: 'Femenino',
  fecha: '7 mayo 2026',
  imagen: 'https://nuevodiarioweb.com.ar/galeria/fotos/2026/04/25/l_1777158976.jpg',
  contenido: `
    <p>La Selección Argentina femenina de básquet 3x3 se quedó con la medalla de bronce en los Juegos Suramericanos de la Juventud tras vencer a Brasil, en una destacada actuación en Panamá.</p>

    <p>Dentro de un equipo sólido, sobresalió la jugadora de Quimsa, Josefina Peralta, quien fue determinante a lo largo del torneo. En el partido por el tercer puesto, lideró la ofensiva con 8 puntos, guiando a la albiceleste al triunfo por 16-11 en una nueva edición del clásico sudamericano.</p>

    <p>El conjunto nacional, que también contó con Rosario Menarvino, Ernestina Suarez y Amparo Juana Arevalo, mostró carácter y alto nivel competitivo. Tras caer en semifinales ante Chile, Argentina reaccionó con personalidad para subirse al podio.</p>

    <p>La jugadora santiagueña tuvo gran participación con Quimsa. Tras su debut con solamente 14 años en La Liga Femenina, ya disputó cuatro temporadas y desde el año pasado integró el Campus de Desarrollo de la C.A.B. U18 además del Preseleccionado 3x3 U19 donde quedó en la lista para viajar a Panamá.</p>
  `
},

{
  id: 65,
  titulo: 'LUCAS VICTORIANO: "QUIMSA, COMO SIEMPRE, IRÁ POR TODO"',
  categoria: 'Equipo',
  fecha: '7 mayo 2026',
  imagen: 'https://www.diariopanorama.com/fotos/cache/notas/2026/02/03/1010x567_lucas-victoriano-quimsa-542279-123642.jpg',
  contenido: `
    <p>Tras los triunfos ante Atenas, Instituto e Independiente en la gira por Córdoba, el entrenador tucumano Lucas Victoriano analizó el rendimiento del equipo y destacó la importancia de haber asegurado el primer lugar de la fase regular.</p>

    <p>“Córdoba es una de las giras más difíciles, más en un cierre de fase regular. Tuvimos algunos pasajes donde nos anotaron muchos puntos en el primer tiempo, así que buscaremos corregir esas lagunas en defensa. Pero logramos las victorias que necesitábamos para quedarnos con el primer puesto”, expresó.</p>

    <p>Además, valoró el presente del equipo y el impacto anímico de este logro: “Estamos contentos por haber terminado como líderes de una competencia muy pareja, que fue muy disputada hasta el último partido. Es un envión anímico para los jugadores, que están muy comprometidos. Ahora veremos cómo se desarrolla la reclasificación para conocer a nuestro rival”.</p>

    <p>Sobre el nivel de la competencia, el ex entrenador de Instituto remarcó: “La Liga es hermosa. Fue una temporada con muchos triunfos de visitantes, donde nadie tiene nada asegurado. Hay que seguir trabajando sobre lo que hacemos bien y mejorar esos pasajes defensivos”.</p>

    <p>Por último, dejó un mensaje para los hinchas: “Es el momento de estar todos juntos. Estamos en una instancia donde el acompañamiento del público es fundamental, así que los esperamos en la cancha. Que sepan que Quimsa, como siempre, irá por todo”.</p>

    <p>La Fusión se quedó por quinta vez con el primer puesto de la fase regular en sus 20 años en la Liga Nacional y ahora deberá esperar por su rival en cuartos de final, que saldrá de La Unión, Independiente, Instituto, Peñarol o San Martín.</p>
  `
},
{
  id: 66,
  titulo: 'INSTITUTO DEJÓ TODO EN EL CIUDAD Y EMPATÓ LA SERIE DE CUARTOS DE FINAL',
  categoria: 'Partido',
  fecha: '11 mayo 2026',
  imagen: 'https://www.diariopanorama.com/fotos/cache/notas/2026/05/11/1010x567_quimsa-instituto-551971-223623.jpg',
  contenido: `Quimsa tuvo un flojo segundo tiempo (30/47) e Instituto se lo llevó por 80 a 74 para igualar la serie que seguirá este jueves en Córdoba.

Quimsa tuvo un mejor inicio con Robinson y Meyinsse, del otro lado Whelan intentó junto a Garello, pero la rotación del local con Orresta y Ruesga aumentaron la diferencia 21 a 13.
En el segundo segmento llegaron los puntos de Garello y contras rápidas de Whelan junto a Copello para descontar con una racha de 8 - 0, tras un tiempo muerto de coach Victoriano el local mejoró en ataque mediante Robinson y Solanas para recuperar la ventaja. La última del primer tiempo quedó en manos de Johnson con un triple para estampar el 44/33 del lado santiagueño.
En el complemento un par de dobles de Johnson aumentaron cifras, pero del otro lado llegaron como respuesta bombas de Monacchi y Copello. Los dirigidos por González levantaron el parcial con libres de Schattmann y un triple de Whelan para quedarse a solo tres, lo ganaba Quimsa a falta de diez minutos 61 a 58.
En el cierre Quimsa se apresuró y falló, Instituto se animó con Whelan y Copello para adueñarse del tanteador 67/63 con 5'44". Robinson se puso el equipo al hombro, pero un golazo de Whelan y una bomba de Schattmann acomodaba todo del lado cordobés. Figueredo con un triple y falta fue el último intento local, pero Saiz con una volcada decretaba el 80/74 de Instituto que empataba la serie de cuartos de final y aseguraba un juego cuatro. Gastón Whelan brilló con 22 puntos y 8 rebotes, además de los 12 de Leonel Schattmann, en los santiagueños 16 de Tyren Johnson y 15 para Brandon Robinson.

La serie continuará el jueves en Córdoba, 21 horas en cancha de Atenas.`
},
{
  id: 67,
  titulo: 'QUIMSA SE QUEDÓ CON EL PRIMER PUNTO DE LOS CUARTOS DE FINAL',
  categoria: 'Partido',
  fecha: '9 mayo 2026',
  imagen: 'https://www.diariopanorama.com/fotos/cache/notas/2026/05/09/1010x567_quimsa-instituto-551670-131717.jpg',
  contenido: `La Fusión goleó a Instituto 85/59 en el inicio de los cuartos de final. Leonardo Lema anotó 21 puntos. La serie continuará el lunes en el Estadio Ciudad.

En el inicio la visita tomó protagonismo con la eficacia de Whelan y Monacchi, del otro lado aciertos de Lema y Ruesga a distancia emparejaron el parcial. Un triple de Ruesga sobre el cierre del cuarto ponía el 19/15 para el local.
El juego siguió palo a palo, hasta que Figueredo y Lema (volcada) aumentaron la ventaja para Quimsa, Instituto estaba en una laguna ofensiva y los santiagueños lo cerraron con Robinson y Meyinsse para un cómodo 41/22 rumbo al entretiempo.
Whelan protagonizó los ataques de Instituto, la Fusión respondió con Robinson y un Figueredo fino desde el perímetro. Las salidas de Vildoza y Monacchi del juego le permitieron al local controlar el cuarto, 68/40 con diez minutos por jugar. El último cuarto no cambió la historia, ambos entrenadores alargaron sus planteles. Claro victoria de Quimsa por 85 a 59.
Leonardo Lema anotó 21 puntos y colaboró con 6 rebotes, además Diego Collomb sumó 12 tantos, Brandon Robinson 10 y Diego Figueredo 10, en la Gloria 13 para Gastón Whelan y 10 Nicolás Copello.

La historia seguirá este lunes desde las 21 horas en el Estadio Ciudad.`
},
{
  id: 68,
  titulo: 'INSTITUTO DEJÓ TODO EN EL CIUDAD Y EMPATÓ LA SERIE DE CUARTOS DE FINAL',
  categoria: 'Partido',
  fecha: '11 mayo 2026',
  imagen: 'https://infodelestero.com/wp-content/uploads/2026/05/image-2026-05-11T120111.168-1146x764.jpg',
  contenido: `Quimsa tuvo un flojo segundo tiempo (30/47) e Instituto se lo llevó por 80 a 74 para igualar la serie que seguirá este jueves en Córdoba.

Quimsa tuvo un mejor inicio con Robinson y Meyinsse, del otro lado Whelan intentó junto a Garello, pero la rotación del local con Orresta y Ruesga aumentaron la diferencia 21 a 13.
En el segundo segmento llegaron los puntos de Garello y contras rápidas de Whelan junto a Copello para descontar con una racha de 8 - 0, tras un tiempo muerto de coach Victoriano el local mejoró en ataque mediante Robinson y Solanas para recuperar la ventaja. La última del primer tiempo quedó en manos de Johnson con un triple para estampar el 44/33 del lado santiagueño.
En el complemento un par de dobles de Johnson aumentaron cifras, pero del otro lado llegaron como respuesta bombas de Monacchi y Copello. Los dirigidos por González levantaron el parcial con libres de Schattmann y un triple de Whelan para quedarse a solo tres, lo ganaba Quimsa a falta de diez minutos 61 a 58.
En el cierre Quimsa se apresuró y falló, Instituto se animó con Whelan y Copello para adueñarse del tanteador 67/63 con 5'44". Robinson se puso el equipo al hombro, pero un golazo de Whelan y una bomba de Schattmann acomodaba todo del lado cordobés. Figueredo con un triple y falta fue el último intento local, pero Saiz con una volcada decretaba el 80/74 de Instituto que empataba la serie de cuartos de final y aseguraba un juego cuatro. Gastón Whelan brilló con 22 puntos y 8 rebotes, además de los 12 de Leonel Schattmann, en los santiagueños 16 de Tyren Johnson y 15 para Brandon Robinson.

La serie continuará el jueves en Córdoba, 21 horas en cancha de Atenas.`
},
{
  id: 69,
  titulo: 'QUIMSA GANÓ EN CÓRDOBA Y QUEDÓ A UN TRIUNFO DE LAS SEMIS',
  categoria: 'Partido',
  fecha: '14 mayo 2026',
  imagen: 'https://infodelestero.com/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-14-at-23.09.09-1-1146x765.jpeg',
  contenido: `Quimsa se quedó con el tercer juego de la serie de cuartos de final por 78/66. Leonardo Lema fue clave con 20 puntos y 10 rebotes.

La Fusión abrió el juego con Robinson anotando 10 puntos consecutivos, el conjunto cordobés lo emparejó con triples de Vildoza. Monacchi tomó el protagonista de las ofensivas en Instituto, pero un doble con foul de Solanas le daba el primero a la visita 24/23.
El duelo siguió palo a palo hasta que Quimsa ajustó la defensa sobre el cierre del primer tiempo, además sumó con Lema y Figueredo para establecer el 41 a 35.
Luego del descanso el juego interno de Saiz fue efectivo junto a un triple de Copello para levantar a la Gloria, los dirigidos por Victoriano encontraron respuestas con un buen ingreso de Orresta y con Lema como mejor carta ofensiva, a falta de diez minutos lo ganaba Quimsa 54 a 47.
En el cierre el santiagueño lo aseguró con Solanas y un triple de Johnson para la victoria por 78/66 que le permite quedar a un triunfo de meterse en semis. Leonardo Lema 20 puntos y 10 rebotes fue el destacado, además de los 14 de Brandon Robinson. En Instituto Tomás Monacchi 16 puntos.

La serie continuará este sábado a las 20:30 horas en el Ángel Sandrín.`
},
{
  id: 70,
  titulo: 'INSTITUTO SE QUEDÓ CON EL JUEGO CUATRO Y TODO SE DEFINE EN EL ESTADIO CIUDAD',
  categoria: 'Partido',
  fecha: '16 mayo 2026',
  imagen: 'https://www.diariopanorama.com/fotos/notas/2026/05/16/quimsa-instituto-552439-221221.jpg',
  contenido: `En el inicio Monacchi con tres triples y el desequilibrio de Whelan adelantó al local, del otro lado llegaron los puntos de Robinson y Figueredo. Ambos entrenadores rotaron equipos, Garello de un lado y Ruesga del otro para un 21 iguales.
Aciertos de Schattmann y Garello le dieron ventaja de nueve a Instituto, la Fusión no estaba fino y un ingreso goleador de Pomare permitía que la Gloria se escape en el score. La visita tenía a Lema como su cuota segura de gol, pero el perímetro de Instituto siguió anotando con Whelan para el 51/33 rumbo al entretiempo.
El conjunto cordobés bajó su eficacia en triples, mientras que Robinson y Figueredo se encargaron de limar la brecha. Sobre el cierre del pasaje, el juego interno de Saiz y una bomba de Monacchi estampaban el 66/56 cordobés.
Dos triples de Copello acomodaron a los dirigidos por González, pero la Fusión se animó con once tantos de Johnson y una volcada de Meyinsse, pero Vildoza con un nuevo acierto a distancia calmó las aguas. En el final Robinson tuvo la última para empatarlo pero no alcanzó, victoria de Instituto 83/80 para llevar todo al quinto juego a disputarse el martes en el Estadio Ciudad. Gastón Whelan 18 puntos y 14 Monacchi fueron los destacados, del otro lado 22 Brandon Robinson y 18 Tyren Johnson.`
},
{
  id: 71,
  titulo: 'QUIMSA SUFRIÓ HASTA EL FINAL PERO SUPERÓ A INSTITUTO PARA METERSE EN SEMIFINALES',
  categoria: 'Partido',
  fecha: '20 mayo 2026',
  imagen: 'https://exclusiva.com.ar/wp-content/uploads/2026/05/17792423763317881158886575683346.webp',
  contenido: `La Fusión se quedó con el quinto punto de la serie ante el elenco cordobés por 75 a 71 y se metió en semis donde enfrentará a Boca nuevamente. Brandon Robinson con 23 puntos y Leonardo Lema con 17 fueron las figuras.

En el inicio Robinson con tres triples adelantó al local 12 a 1 frente a un Instituto errático en cuatro minutos. La dupla Whelan - Vildoza descontó en la visita, pero nuevamente Robinson y Solanas acomodaron a la Fusión 30/17.
El segundo segmento comenzó parejo, pero los dirigidos por Victoriano se volvieron a escapar con una seguidilla de Lema. Saiz cerca del aro y libres de Whelan descontaron de nuevo, arriba Quimsa rumbo al entretiempo 45 a 29.
Instituto salió mejor al complemento, triples de Whelan y Monacchi junto al juego interno de Saiz descontaron para ponerse a diez, en el dueño de casa llegó Solanas con cinco puntos, pero la Gloria se ponía a ocho. Quimsa arriba 61/53.
El último pasaje tuvo cinco minutos poco efectivos, pero muy luchados, los santiagueños dejaron espacios aprovechados por Garello y Whelan para seguir limando la brecha, arriba Quimsa 67/64 con 2'22" en el reloj. Una bomba de Lema y junto a dos libres acomodaron mejor a la Fusión, la visita tuvo el último intento con Schattmann pero Whelan perdió el balón y los dirigidos por Victoriano lo cerraron con dos simples de Robinson para llevarse la victoria por 75 a 71. Brandon Robinson sumó 23 tantos, Leonardo Lema 17 puntos y 15 rebotes además de los 13 con 9 rebotes de Jerome Meyinsse, del otro costado 16 Gastón Whelan.

La Asociación Atlética Quimsa dejó en el camino a Instituto y se metió entre los cuatro mejores equipos del torneo. Novena vez para el conjunto santiagueño en semifinales (sexta de forma consecutiva) donde enfrentará a Boca.`
},
{
  id: 72,
  titulo: 'LUCAS VICTORIANO LUEGO DE LA CLASIFICACIÓN A SEMIFINALES',
  categoria: 'Declaraciones',
  fecha: '21 mayo 2026',
  imagen: 'https://infodelestero.com/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-20-at-10.39.29-AM.jpeg',
  contenido: `Tras la clasificación de Quimsa a las semifinales de La Liga, el entrenador Lucas Victoriano analizó el triunfo ante Instituto y destacó el trabajo realizado por sus jugadores en una serie muy exigente.

“Quiero felicitar a Instituto por ser un gran y digno rival. Obviamente también felicitar a mis jugadores, que entraron desde el primer segundo sabiendo de la importancia del partido, con un excelente primer cuarto, con mucho ritmo y aciertos”.

Además, se refirió a la clasificación y al contexto físico con el que llega el equipo a la próxima instancia: “No nos dejamos llevar por las presiones externas. Logramos pasar a una semifinal donde nos espera otro duro rival como lo es Boca, con un calendario que te tiene arrinconado, con solo unos días después de disputar un juego cinco”.

Por último, el ex entrenador de Instituto y Regatas comenzó a palpitar el duelo frente al conjunto porteño: “Ahora nos toca hacer el estudio junto con el cuerpo técnico para darles a los jugadores el panorama del rival y lo que nosotros queremos hacer en la cancha. Sabemos mucho de Boca, sabemos que nos enfrentamos al bicampeón de La Liga y campeón de la BCL Americas, que es uno de los candidatos, como también lo somos nosotros. Será una serie muy difícil”.

La Fusión volverá a los entrenamientos este jueves pensando en los dos primeros juegos de la serie ante Boca, que se disputarán en el Estadio Ciudad.`
},
{
  id: 73,
  titulo: 'QUIMSA PEGÓ PRIMERO Y SE ADELANTÓ EN LA SERIE FRENTE A BOCA',
  categoria: 'Partido',
  fecha: '22 mayo 2026',
  imagen: 'https://www.laliganacional.com.ar/archivos/noticias/52186/zoom-foto-75363.jpg',
  contenido: `La Fusión se quedó con el primer punto de la serie por 88 a 76. Brandon Robinson anotó 27 puntos. El lunes será el segundo partido.

En el inicio Figueredo y Robinson tomaron la posta en ofensiva para el seis a cero local frente a un Boca errático (0/6 en tiros). Smith y Barreiro levantaron a la visita, pero la Fusión se llevó el primero gracias a Orresta y Ruesga por 22 a 14.
Primero Langston y luego Smith descontaron en el Xeneize, en Quimsa Robinson y Johnson mantuvieron el liderazgo en un pasaje palo a palo. Rumbo al entretiempo los dirigidos por Victoriano encontraron un doble de Figueredo para establecer el 42 a 35.
Meyinsse y Robinson ponían un parcial de seis a cero para que los santiagueños aumenten la ventaja. La visita reaccionó mejorando en ataque con los primeros puntos de Cáffaro y un triple de Barreiro, pero Robinson siguió encendido. Tras unos minutos de gol a gol, Quimsa arriba 65/55 a falta de un cuarto.
Cinco puntos de Robinson asomaron en el lado santiagueño, pero la respuesta de Boca no tardó con efectividad desde el perímetro mediante Faggiano. Cuando Freeman tomó el protagonismo con sus puntos tuvo que salir por faltas, el Xeneize tuvo su último intento con Cáffaro cerca del aro, pero Quimsa lo cerró tomando rebotes ofensivos y seis puntos de Lema para imponerse 88/76 y así adelantarse en la llave de semifinales.
Brandon Robinson brilló con 27 puntos, además Leonardo Lema 12 con 8 rebotes y Jerome Meyinsse 12 puntos. Del otro lado 15 Michael Smith.

La serie continuará el lunes a las 21:30 horas nuevamente en el Estadio Ciudad.`
}
];

export default noticias;
